import { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Badge } from '../components/ui/badge';
import { Textarea } from '../components/ui/textarea';
import { Checkbox } from '../components/ui/checkbox';
import ShopPublish from '../components/ShopPublish';
import { Combobox } from '../components/ui/combobox';
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle, 
  DialogTrigger,
  DialogFooter 
} from '../components/ui/dialog';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../components/ui/alert-dialog';
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/select';
import { 
  ArrowLeft,
  ChevronLeft,
  ChevronRight,
  Plus, 
  Trash2, 
  Wrench,
  Calendar,
  User,
  Euro,
  Package,
  Edit,
  ShoppingCart,
  FileText,
  Image,
  Shield,
  TrendingUp,
  TrendingDown,
  Hash,
  Upload,
  Camera,
  Tag,
  Palette,
  Circle,
  Cog,
  List,
  ArrowUpDown,
  ArrowUp,
  ArrowDown,
  Zap,
  Gauge,
  AlertCircle,
  AlertTriangle,
  Clock,
  RefreshCw,
  Bike,
  Printer,
  UserCheck,
  MessageSquare,
  Save,
  X,
  Calculator,
  DollarSign,
  Pencil,
  Check,
  Lock
} from 'lucide-react';
import { toast } from 'sonner';
import PrintLabelModal from '../components/PrintLabelModal';
import PurchaseDocs from '../components/PurchaseDocs';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function BicycleDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { isAdmin, user } = useAuth();
  
  const [bicycle, setBicycle] = useState(null);
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isRevisionDialogOpen, setIsRevisionDialogOpen] = useState(false);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [isSellDialogOpen, setIsSellDialogOpen] = useState(false);
  const [isEditSaleDialogOpen, setIsEditSaleDialogOpen] = useState(false);
  const [deleteRevisionId, setDeleteRevisionId] = useState(null);
  const [uploadingPhoto, setUploadingPhoto] = useState(false);
  const [isHistoryDialogOpen, setIsHistoryDialogOpen] = useState(false);
  const [historySortBy, setHistorySortBy] = useState('date'); // 'date' or 'material'
  const [historySortOrder, setHistorySortOrder] = useState('desc'); // 'asc' or 'desc'
  const [isPrintLabelOpen, setIsPrintLabelOpen] = useState(false);
  const [statusChanging, setStatusChanging] = useState(false);
  const [statusComment, setStatusComment] = useState('');
  const [loanPersonName, setLoanPersonName] = useState('');
  const [loanDate, setLoanDate] = useState(new Date().toISOString().split('T')[0]);
  const [loanComment, setLoanComment] = useState('');
  const [loanReturnDate, setLoanReturnDate] = useState('');
  
  // General comment state
  const [generalComment, setGeneralComment] = useState('');
  const [savingComment, setSavingComment] = useState(false);
  
  // Edit revision state
  const [isEditRevisionDialogOpen, setIsEditRevisionDialogOpen] = useState(false);
  const [editingRevision, setEditingRevision] = useState(null);
  const [editRevisionData, setEditRevisionData] = useState({
    description: '',
    materials: [],
    current_km: ''
  });
  const [editMaterialFilters, setEditMaterialFilters] = useState({});
  
  const [componentOptions, setComponentOptions] = useState({
    colors: [],
    wheels: [],
    groupsets: []
  });
  
  // Navigation between bicycles
  const [navList, setNavList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  
  // Catalog models for modelo selector
  const [catalogModels, setCatalogModels] = useState([]);
  const [catalogTallas, setCatalogTallas] = useState([]);
  const [catalogCategorias, setCatalogCategorias] = useState([]);
  
  const [newRevision, setNewRevision] = useState({
    description: '',
    materials: []
  });

  const [materialFilters, setMaterialFilters] = useState({});

  const [editData, setEditData] = useState({
    number: '',
    model: '',
    modelo_id: '',
    size: '',
    category: '',
    status: '',
    photo_url: '',
    frame_number: '',
    invoice_number: '',
    delivery_note_number: '',
    purchase_date: '',
    purchase_price: '',
    warranty_active: false,
    color: '',
    wheels: '',
    groupset: '',
    model_year: '',
    is_electric: false,
    cambio_electronico: false,
    codigo_bloqueo: '',
    custom_components: {}
  });

  // State for adding new custom component
  const [newComponent, setNewComponent] = useState({ name: '', value: '' });

  const [sellData, setSellData] = useState({
    sold_price: '',
    rental_income: '',
    sold_to: '',
    amount_paid: ''
  });

  const [editSaleData, setEditSaleData] = useState({
    sold_price: '',
    rental_income: '',
    sold_to: ''
  });

  // Sale invoice upload state
  const [uploadingInvoice, setUploadingInvoice] = useState(false);

  // Reactivation state
  const [isReactivateOpen, setIsReactivateOpen] = useState(false);
  const [reactivatePrice, setReactivatePrice] = useState('');
  const [lifecycles, setLifecycles] = useState(null);
  
  // Stolen state
  const [stolenDate, setStolenDate] = useState(new Date().toISOString().split('T')[0]);
  const [stolenNotes, setStolenNotes] = useState('');
  const [uploadingStolenFile, setUploadingStolenFile] = useState(false);
  
  // Price suggestion
  const [suggestedPrice, setSuggestedPrice] = useState(null);

  // Second-hand formula pricing state
  const [priceFormulas, setPriceFormulas] = useState([]);
  const [secondhandPriceData, setSecondhandPriceData] = useState(null);
  const [loadingPrice, setLoadingPrice] = useState(false);
  const [manualPriceInput, setManualPriceInput] = useState('');
  const [savingFormula, setSavingFormula] = useState(false);

  // Revision form state including km for electric bikes
  const [revisionKm, setRevisionKm] = useState('');

  // Image loading state
  const [imageError, setImageError] = useState(false);
  const [imageRetryCount, setImageRetryCount] = useState(0);
  const [imageLoading, setImageLoading] = useState(false); // Start as false, set true only when loading

  // Load navigation list from localStorage
  useEffect(() => {
    const savedList = localStorage.getItem('bicycleNavList');
    if (savedList) {
      try {
        const list = JSON.parse(savedList);
        setNavList(list);
        const index = list.indexOf(id);
        setCurrentIndex(index);
      } catch (e) {
        console.error('Error parsing nav list:', e);
      }
    }
  }, [id]);

  useEffect(() => {
    fetchBicycle();
    fetchMaterials();
    fetchComponentOptions();
    fetchCatalogModels();
    fetchLifecycles();
    setHasUnsavedChanges(false);
  }, [id]);

  const fetchCatalogModels = async () => {
    try {
      const res = await axios.get(`${API}/catalog/models`);
      setCatalogModels(res.data);
    } catch {}
    try {
      const resT = await axios.get(`${API}/catalog/tallas`);
      setCatalogTallas(resT.data || []);
    } catch {}
    try {
      const resC = await axios.get(`${API}/catalog/categorias`);
      setCatalogCategorias(resC.data || []);
    } catch {}
  };

  const fetchComponentOptions = async () => {
    try {
      const response = await axios.get(`${API}/components/options`);
      setComponentOptions(response.data);
    } catch (error) {
      console.error('Error fetching component options:', error);
    }
  };

  const handleDeleteComponentOption = async (field, value) => {
    if (!isAdmin) return;
    
    try {
      // First check how many bicycles use this option
      const countResponse = await axios.get(`${API}/components/options/${field}/${encodeURIComponent(value)}/count`);
      const count = countResponse.data.count;
      
      const confirmMessage = count > 0 
        ? `Esta opción está usada en ${count} bicicleta(s). ¿Eliminarla? Se borrará de todas las bicicletas.`
        : `¿Eliminar la opción "${value}"?`;
      
      if (window.confirm(confirmMessage)) {
        await axios.delete(`${API}/components/options?field=${field}&value=${encodeURIComponent(value)}`);
        toast.success(`Opción "${value}" eliminada`);
        fetchComponentOptions();
        
        // If current bike had this value, clear it from editData
        if (editData[field] === value) {
          setEditData(prev => ({ ...prev, [field]: '' }));
        }
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al eliminar la opción');
    }
  };

  const fetchBicycle = async () => {
    try {
      const response = await axios.get(`${API}/bicycles/${id}`);
      setBicycle(response.data);
      // Reset image state when bicycle changes
      setImageError(false);
      setImageRetryCount(0);
      // Only set loading if there's actually a photo URL
      setImageLoading(!!response.data.photo_url);
      // Load general comment
      setGeneralComment(response.data.general_comment || '');
      setEditData({
        number: response.data.number,
        model: response.data.model,
        modelo_id: response.data.modelo_id || '',
        size: response.data.size,
        category: response.data.category || '',
        status: response.data.status,
        photo_url: response.data.photo_url || '',
        frame_number: response.data.frame_number || '',
        invoice_number: response.data.invoice_number || '',
        delivery_note_number: response.data.delivery_note_number || '',
        purchase_date: response.data.purchase_date || '',
        purchase_price: response.data.purchase_price || '',
        warranty_active: response.data.warranty_active || false,
        color: response.data.color || '',
        wheels: response.data.wheels || '',
        groupset: response.data.groupset || '',
        model_year: response.data.model_year || '',
        is_electric: response.data.is_electric || false,
        cambio_electronico: response.data.cambio_electronico || false,
        codigo_bloqueo: response.data.codigo_bloqueo || '',
        custom_components: response.data.custom_components || {}
      });
    } catch (error) {
      console.error('Error fetching bicycle:', error);
      toast.error('Error al cargar la bicicleta');
      navigate('/bicycles');
    } finally {
      setLoading(false);
    }
  };

  // Function to retry loading the image
  const handleImageRetry = () => {
    if (imageRetryCount < 3) {
      setImageError(false);
      setImageLoading(true);
      setImageRetryCount(prev => prev + 1);
    }
  };

  // Generate image URL with cache busting - safe version
  const getImageUrl = (photoUrl) => {
    try {
      if (!photoUrl) return null;
      if (!BACKEND_URL) return null;
      const cacheBuster = imageRetryCount > 0 ? `?retry=${imageRetryCount}&t=${Date.now()}` : '';
      return `${BACKEND_URL}${photoUrl}${cacheBuster}`;
    } catch (e) {
      console.error('Error generating image URL:', e);
      return null;
    }
  };

  const fetchMaterials = async () => {
    try {
      const response = await axios.get(`${API}/materials`);
      setMaterials(response.data);
    } catch (error) {
      console.error('Error fetching materials:', error);
    }
  };

  // Fetch price formulas for second-hand
  const fetchPriceFormulas = async () => {
    try {
      const response = await axios.get(`${API}/config/price-formulas`);
      setPriceFormulas(response.data);
    } catch (error) {
      console.error('Error fetching price formulas:', error);
    }
  };

  // Fetch secondhand price for this bicycle
  const fetchSecondhandPrice = async () => {
    if (!id) return;
    setLoadingPrice(true);
    try {
      const response = await axios.get(`${API}/bicycles/${id}/secondhand-price`);
      setSecondhandPriceData(response.data);
      if (response.data.price_type === 'manual') {
        setManualPriceInput(response.data.net_price?.toString() || '');
      }
    } catch (error) {
      console.error('Error fetching secondhand price:', error);
    } finally {
      setLoadingPrice(false);
    }
  };

  // Apply a formula to this bicycle
  const handleApplyFormula = async (formulaId) => {
    setSavingFormula(true);
    try {
      const params = new URLSearchParams();
      if (formulaId) params.append('formula_id', formulaId);
      await axios.put(`${API}/bicycles/${id}/secondhand-formula?${params.toString()}`);
      toast.success('Fórmula aplicada');
      await fetchSecondhandPrice();
      await fetchBicycle();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al aplicar fórmula');
    } finally {
      setSavingFormula(false);
    }
  };

  // Set manual sale price
  const handleSetManualPrice = async () => {
    const price = parseFloat(manualPriceInput);
    if (!price || price <= 0) {
      toast.error('Introduce un precio válido');
      return;
    }
    setSavingFormula(true);
    try {
      await axios.put(`${API}/bicycles/${id}/secondhand-formula?manual_price=${price}`);
      toast.success('Precio manual establecido');
      await fetchSecondhandPrice();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al establecer precio');
    } finally {
      setSavingFormula(false);
    }
  };

  // Clear manual price
  const handleClearManualPrice = async () => {
    setSavingFormula(true);
    try {
      await axios.put(`${API}/bicycles/${id}/secondhand-formula?manual_price=0`);
      toast.success('Precio manual eliminado');
      setManualPriceInput('');
      await fetchSecondhandPrice();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al eliminar precio manual');
    } finally {
      setSavingFormula(false);
    }
  };

  // Fetch formulas and price when bicycle loads
  useEffect(() => {
    if (bicycle && bicycle.status !== 'vendida') {
      fetchPriceFormulas();
      fetchSecondhandPrice();
    }
  }, [bicycle?.id]);

  // Navigation functions
  const canNavigatePrev = currentIndex > 0;
  const canNavigateNext = currentIndex >= 0 && currentIndex < navList.length - 1;

  const navigateTo = useCallback((targetId) => {
    if (hasUnsavedChanges) {
      setPendingNavigation(targetId);
    } else {
      navigate(`/bicycles/${targetId}`);
    }
  }, [hasUnsavedChanges, navigate]);

  const navigatePrev = () => {
    if (canNavigatePrev) {
      navigateTo(navList[currentIndex - 1]);
    }
  };

  const navigateNext = () => {
    if (canNavigateNext) {
      navigateTo(navList[currentIndex + 1]);
    }
  };

  const confirmNavigation = () => {
    if (pendingNavigation) {
      setHasUnsavedChanges(false);
      navigate(`/bicycles/${pendingNavigation}`);
      setPendingNavigation(null);
    }
  };

  const cancelNavigation = () => {
    setPendingNavigation(null);
  };

  const handleAddMaterial = () => {
    setNewRevision({
      ...newRevision,
      materials: [
        ...newRevision.materials,
        { material_id: '', material_name: '', quantity: 1, unit_price: 0, total_price: 0 }
      ]
    });
  };

  const handleMaterialChange = (index, field, value) => {
    const updated = [...newRevision.materials];
    
    if (field === 'material_id') {
      const material = materials.find(m => m.id === value);
      if (material) {
        updated[index] = {
          ...updated[index],
          material_id: value,
          material_name: material.name,
          unit_price: material.price,
          total_price: updated[index].quantity * material.price
        };
      }
    } else if (field === 'quantity') {
      const qty = parseFloat(value) || 0;
      updated[index] = {
        ...updated[index],
        quantity: qty,
        total_price: qty * updated[index].unit_price
      };
    }
    
    setNewRevision({ ...newRevision, materials: updated });
  };

  const handleRemoveMaterial = (index) => {
    const updated = newRevision.materials.filter((_, i) => i !== index);
    setNewRevision({ ...newRevision, materials: updated });
  };

  // Custom components handlers
  const handleAddCustomComponent = () => {
    if (!newComponent.name.trim()) {
      toast.error('El nombre del componente es obligatorio');
      return;
    }
    const normalizedName = newComponent.name.trim().toLowerCase();
    const updatedComponents = {
      ...editData.custom_components,
      [normalizedName]: newComponent.value.trim()
    };
    setEditData({ ...editData, custom_components: updatedComponents });
    setNewComponent({ name: '', value: '' });
  };

  const handleUpdateCustomComponent = (name, value) => {
    const updatedComponents = {
      ...editData.custom_components,
      [name]: value
    };
    setEditData({ ...editData, custom_components: updatedComponents });
  };

  const handleRemoveCustomComponent = (name) => {
    const updatedComponents = { ...editData.custom_components };
    delete updatedComponents[name];
    setEditData({ ...editData, custom_components: updatedComponents });
  };

  const handleAddRevision = async (e) => {
    e.preventDefault();
    try {
      const revisionData = {
        ...newRevision,
        current_km: bicycle?.is_electric && revisionKm ? parseInt(revisionKm) : null
      };
      await axios.post(`${API}/bicycles/${id}/revisions`, revisionData);
      toast.success('Revisión añadida correctamente');
      setIsRevisionDialogOpen(false);
      setNewRevision({ description: '', materials: [] });
      setMaterialFilters({});
      setRevisionKm('');
      fetchBicycle();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al añadir la revisión');
    }
  };

  const handleDeleteRevision = async () => {
    if (!deleteRevisionId) return;
    try {
      await axios.delete(`${API}/revisions/${deleteRevisionId}`);
      toast.success('Revisión eliminada');
      setDeleteRevisionId(null);
      fetchBicycle();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al eliminar');
    }
  };

  // Save general comment
  const handleSaveComment = async () => {
    setSavingComment(true);
    try {
      await axios.put(`${API}/bicycles/${id}/comment`, { general_comment: generalComment });
      toast.success('Comentario guardado');
      fetchBicycle();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al guardar comentario');
    } finally {
      setSavingComment(false);
    }
  };

  // Delete general comment
  const handleDeleteComment = async () => {
    setSavingComment(true);
    try {
      await axios.put(`${API}/bicycles/${id}/comment`, { general_comment: '' });
      setGeneralComment('');
      toast.success('Comentario eliminado');
      fetchBicycle();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al eliminar comentario');
    } finally {
      setSavingComment(false);
    }
  };

  // Open edit revision dialog
  const handleOpenEditRevision = (revision) => {
    setEditingRevision(revision);
    setEditRevisionData({
      description: revision.description || '',
      materials: revision.materials?.map(m => ({
        material_id: m.material_id,
        material_name: m.material_name,
        quantity: m.quantity,
        unit_price: m.unit_price,
        total_price: m.total_price
      })) || [],
      current_km: revision.current_km?.toString() || ''
    });
    setEditMaterialFilters({});
    setIsEditRevisionDialogOpen(true);
  };

  // Add material to edit revision
  const handleEditAddMaterial = (material) => {
    setEditRevisionData(prev => ({
      ...prev,
      materials: [
        ...prev.materials,
        {
          material_id: material.id,
          material_name: material.name,
          quantity: 1,
          unit_price: material.price,
          total_price: material.price
        }
      ]
    }));
  };

  // Update material in edit revision
  const handleEditUpdateMaterial = (index, field, value) => {
    const updated = [...editRevisionData.materials];
    updated[index] = { ...updated[index], [field]: value };
    if (field === 'quantity') {
      updated[index].total_price = updated[index].unit_price * value;
    }
    setEditRevisionData({ ...editRevisionData, materials: updated });
  };

  // Remove material from edit revision
  const handleEditRemoveMaterial = (index) => {
    const updated = editRevisionData.materials.filter((_, i) => i !== index);
    setEditRevisionData({ ...editRevisionData, materials: updated });
  };

  // Save edit revision
  const handleSaveEditRevision = async (e) => {
    e.preventDefault();
    if (!editingRevision) return;
    
    try {
      const payload = {
        description: editRevisionData.description,
        materials: editRevisionData.materials.map(m => ({
          material_id: m.material_id,
          material_name: m.material_name,
          quantity: m.quantity,
          unit_price: m.unit_price,
          total_price: m.total_price
        }))
      };
      
      // Add km for electric bikes
      if (bicycle?.is_electric && editRevisionData.current_km) {
        payload.current_km = parseInt(editRevisionData.current_km);
      }
      
      await axios.put(`${API}/revisions/${editingRevision.id}`, payload);
      toast.success('Revisión actualizada correctamente');
      setIsEditRevisionDialogOpen(false);
      setEditingRevision(null);
      fetchBicycle();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al actualizar la revisión');
    }
  };

  const handleUpdateBicycle = async (e) => {
    e.preventDefault();
    
    // PIN is optional. If provided, must be exactly 6 digits.
    if (editData.cambio_electronico) {
      const code = (editData.codigo_bloqueo || '').trim();
      if (code && !/^\d{6}$/.test(code)) {
        toast.error('El código de bloqueo debe ser exactamente 6 dígitos (o dejarlo vacío)');
        return;
      }
    }
    
    try {
      const dataToSend = {
        ...editData,
        purchase_price: editData.purchase_price ? parseFloat(editData.purchase_price) : null
      };
      // Remove electronic shifting fields from main update (has its own endpoint)
      delete dataToSend.cambio_electronico;
      delete dataToSend.codigo_bloqueo;
      
      await axios.put(`${API}/bicycles/${id}`, dataToSend);
      
      // Save electronic shifting via dedicated endpoint (all users can access)
      await axios.put(`${API}/bicycles/${id}/electronic-shifting`, {
        cambio_electronico: editData.cambio_electronico,
        codigo_bloqueo: editData.cambio_electronico ? (editData.codigo_bloqueo || '') : null
      });
      
      toast.success('Bicicleta actualizada');
      setIsEditDialogOpen(false);
      fetchBicycle();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al actualizar');
    }
  };

  const handleStatusChange = async (newStatus) => {
    // Validate loan fields if changing to "prestada"
    if (newStatus === 'prestada' && !loanPersonName.trim()) {
      toast.error('El nombre de la persona es obligatorio para préstamos');
      return;
    }
    
    setStatusChanging(true);
    try {
      const data = {
        status: newStatus,
        status_comment: statusComment
      };
      
      // Add loan fields if status is "prestada"
      if (newStatus === 'prestada') {
        data.loan_person_name = loanPersonName.trim();
        data.loan_date = loanDate;
        data.loan_comment = loanComment;
        data.loan_return_date = loanReturnDate || null;
      }
      
      // Add stolen fields if status is "robada"
      if (newStatus === 'robada') {
        data.stolen_date = stolenDate;
        data.stolen_notes = stolenNotes;
      }
      
      await axios.put(`${API}/bicycles/${id}/status`, data);
      toast.success(`Estado cambiado a "${newStatus}"`);
      setStatusComment('');
      setLoanPersonName('');
      setLoanDate(new Date().toISOString().split('T')[0]);
      setLoanComment('');
      setLoanReturnDate('');
      setStolenDate(new Date().toISOString().split('T')[0]);
      setStolenNotes('');
      fetchBicycle();
      fetchLifecycles();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al cambiar estado');
    } finally {
      setStatusChanging(false);
    }
  };


  const handlePhotoUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    
    // Validate file type
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      toast.error('Solo se permiten archivos JPG, JPEG, PNG o WEBP');
      return;
    }
    
    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      toast.error('La imagen no puede superar los 5MB');
      return;
    }
    
    setUploadingPhoto(true);
    setImageError(false);
    setImageLoading(true);
    setImageRetryCount(0);
    
    const formData = new FormData();
    formData.append('file', file);
    
    try {
      const response = await axios.post(`${API}/bicycles/${id}/upload-photo`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      console.log('Upload response:', response.data);
      
      // Verify the image is accessible before showing success
      const imageUrl = `${BACKEND_URL}${response.data.photo_url}?t=${Date.now()}`;
      console.log('Verifying image at:', imageUrl);
      
      const img = new Image();
      img.onload = () => {
        toast.success(`Foto subida correctamente (${Math.round(response.data.file_size / 1024)} KB)`);
        setImageLoading(false);
        fetchBicycle();
      };
      img.onerror = () => {
        // Image uploaded but not accessible
        console.error('Image verification failed for:', imageUrl);
        toast.error('La foto se subió pero no es accesible. Contacta al administrador.');
        setImageError(true);
        setImageLoading(false);
        fetchBicycle();
      };
      img.src = imageUrl;
      
    } catch (error) {
      console.error('Upload error:', error.response?.data);
      const errorMessage = error.response?.data?.detail || 'Error al subir la foto';
      toast.error(errorMessage);
      setImageLoading(false);
    } finally {
      setUploadingPhoto(false);
      // Reset file input
      e.target.value = '';
    }
  };

  const handleSellBicycle = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/bicycles/${id}/sell`, {
        sold_price: parseFloat(sellData.sold_price),
        rental_income: parseFloat(sellData.rental_income) || 0,
        sold_to: sellData.sold_to || null,
        amount_paid: parseFloat(sellData.amount_paid) || 0
      });
      const pend = (parseFloat(sellData.sold_price) || 0) - (parseFloat(sellData.amount_paid) || 0);
      toast.success(pend > 0 ? 'Bicicleta vendida pendiente de cobro' : 'Bicicleta marcada como vendida');
      setIsSellDialogOpen(false);
      setSellData({ sold_price: '', rental_income: '', sold_to: '', amount_paid: '' });
      fetchBicycle();
      fetchLifecycles();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al registrar la venta');
    }
  };

  const fetchLifecycles = async () => {
    try {
      const res = await axios.get(`${API}/bicycles/${id}/lifecycles`);
      setLifecycles(res.data);
    } catch { /* ignore for old bikes */ }
  };

  const handleReactivate = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/bicycles/${id}/reactivate`, {
        purchase_price: parseFloat(reactivatePrice) || 0
      });
      toast.success('Bicicleta reactivada - nuevo ciclo de vida iniciado');
      setIsReactivateOpen(false);
      setReactivatePrice('');
      fetchBicycle();
      fetchLifecycles();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al reactivar');
    }
  };

  const handleStolenFileUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploadingStolenFile(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      await axios.post(`${API}/bicycles/${id}/stolen-attachments`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      toast.success('Archivo adjuntado');
      fetchBicycle();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al subir archivo');
    } finally {
      setUploadingStolenFile(false);
      e.target.value = '';
    }
  };

  const handleDeleteStolenAttachment = async (attachmentId) => {
    try {
      await axios.delete(`${API}/bicycles/${id}/stolen-attachments/${attachmentId}`);
      toast.success('Adjunto eliminado');
      fetchBicycle();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al eliminar');
    }
  };

  const handleUpdateSaleData = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API}/bicycles/${id}/sale-data`, {
        sold_price: parseFloat(editSaleData.sold_price),
        rental_income: parseFloat(editSaleData.rental_income) || 0,
        sold_to: editSaleData.sold_to || null
      });
      toast.success('Datos de venta actualizados');
      setIsEditSaleDialogOpen(false);
      fetchBicycle();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al actualizar los datos de venta');
    }
  };

  const openEditSaleDialog = () => {
    setEditSaleData({
      sold_price: bicycle.sold_price?.toString() || '',
      rental_income: bicycle.rental_income?.toString() || '0',
      sold_to: bicycle.sold_to || ''
    });
    setIsEditSaleDialogOpen(true);
  };

  // Handle sale invoice upload
  const handleInvoiceUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      toast.error('Solo se permiten archivos PDF, JPG o PNG');
      return;
    }
    
    if (file.size > 10 * 1024 * 1024) {
      toast.error('El archivo no puede superar los 10MB');
      return;
    }
    
    setUploadingInvoice(true);
    const formData = new FormData();
    formData.append('file', file);
    
    try {
      const response = await axios.post(`${API}/bicycles/${id}/upload-sale-invoice`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      toast.success('Factura de venta subida correctamente');
      fetchBicycle();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al subir la factura');
    } finally {
      setUploadingInvoice(false);
      e.target.value = '';
    }
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      activa: { label: 'Activa', class: 'bg-blue-100 text-blue-800 border-blue-200' },
      en_taller: { label: 'En Taller', class: 'bg-orange-100 text-orange-800 border-orange-200' },
      retirada: { label: 'Retirada', class: 'bg-slate-100 text-slate-600 border-slate-200' },
      vendida: { label: 'Vendida', class: 'bg-green-100 text-green-800 border-green-200' },
      reservada: { label: 'Reservada (Tienda)', class: 'bg-sky-100 text-sky-800 border-sky-200' },
      robada: { label: 'Robada', class: 'bg-red-100 text-red-800 border-red-200' }
    };
    const config = statusConfig[status] || statusConfig.activa;
    return (
      <Badge variant="outline" className={`${config.class} text-sm px-3 py-1`}>
        {config.label}
      </Badge>
    );
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR'
    }).format(value);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  // Calculate second-hand sale price
  const calculateSecondHandPrice = () => {
    if (!bicycle) return null;
    
    const purchasePrice = bicycle.purchase_price || 0;
    const maintenanceCost = bicycle.total_maintenance_cost || 0;
    const basePrice = purchasePrice + maintenanceCost;
    
    if (basePrice === 0) return null;
    
    // Get months since purchase date
    const purchaseDate = bicycle.purchase_date ? new Date(bicycle.purchase_date) : new Date(bicycle.created_at);
    const now = new Date();
    const monthsDiff = (now.getFullYear() - purchaseDate.getFullYear()) * 12 + 
                       (now.getMonth() - purchaseDate.getMonth());
    
    let multiplier;
    if (monthsDiff <= 2) {
      // First 2 months: +10%
      multiplier = 1.10;
    } else {
      // After 2 months: start at 1.10 and subtract 2% per additional month
      const additionalMonths = monthsDiff - 2;
      multiplier = 1.10 - (additionalMonths * 0.02);
      // Don't let it go below a minimum (e.g., 20% of base)
      multiplier = Math.max(multiplier, 0.20);
    }
    
    const secondHandPrice = basePrice * multiplier;
    
    return {
      basePrice,
      multiplier,
      monthsDiff,
      secondHandPrice,
      isAppreciating: monthsDiff <= 2
    };
  };

  const secondHandData = calculateSecondHandPrice();

  // Get flattened history data for detailed view (one row per material used)
  const getDetailedHistory = () => {
    if (!bicycle?.revisions) return [];
    
    const flattenedData = [];
    
    bicycle.revisions.forEach(revision => {
      if (revision.materials?.length > 0) {
        revision.materials.forEach(mat => {
          flattenedData.push({
            revisionId: revision.id,
            date: revision.date,
            description: revision.description,
            mechanicName: revision.mechanic_name,
            materialName: mat.material_name,
            quantity: mat.quantity,
            unitPrice: mat.unit_price,
            totalPrice: mat.total_price,
            revisionTotalCost: revision.total_cost
          });
        });
      } else {
        // Revision without materials (only labor)
        flattenedData.push({
          revisionId: revision.id,
          date: revision.date,
          description: revision.description,
          mechanicName: revision.mechanic_name,
          materialName: '(Sin materiales)',
          quantity: 0,
          unitPrice: 0,
          totalPrice: 0,
          revisionTotalCost: revision.total_cost
        });
      }
    });
    
    return flattenedData;
  };

  // Sort the detailed history
  const getSortedHistory = () => {
    const data = getDetailedHistory();
    
    return data.sort((a, b) => {
      let comparison = 0;
      
      if (historySortBy === 'date') {
        comparison = new Date(a.date) - new Date(b.date);
      } else if (historySortBy === 'material') {
        comparison = a.materialName.localeCompare(b.materialName, 'es');
      }
      
      return historySortOrder === 'asc' ? comparison : -comparison;
    });
  };

  const toggleSort = (field) => {
    if (historySortBy === field) {
      setHistorySortOrder(historySortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setHistorySortBy(field);
      setHistorySortOrder('desc');
    }
  };

  const SortIcon = ({ field }) => {
    if (historySortBy !== field) return <ArrowUpDown size={14} className="opacity-40" />;
    return historySortOrder === 'asc' ? <ArrowUp size={14} /> : <ArrowDown size={14} />;
  };

  const totalRevisionCost = newRevision.materials.reduce((sum, m) => sum + m.total_price, 0);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="spinner w-8 h-8" />
      </div>
    );
  }

  if (!bicycle) return null;

  return (
    <div className="space-y-6 animate-fadeIn" data-testid="bicycle-detail-page">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center gap-4">
          <Button 
            variant="ghost" 
            onClick={() => navigate('/bicycles')}
            className="gap-2"
            data-testid="back-btn"
          >
            <ArrowLeft size={18} />
            Volver
          </Button>
          
          {/* Navigation arrows */}
          {navList.length > 1 && (
            <div className="flex items-center gap-1 bg-slate-100 rounded-lg p-1">
              <Button
                variant="ghost"
                size="sm"
                onClick={navigatePrev}
                disabled={!canNavigatePrev}
                className="h-8 w-8 p-0"
                title="Bicicleta anterior"
                data-testid="nav-prev-btn"
              >
                <ChevronLeft size={20} />
              </Button>
              <span className="text-xs text-slate-500 px-2 min-w-[60px] text-center">
                {currentIndex + 1} / {navList.length}
              </span>
              <Button
                variant="ghost"
                size="sm"
                onClick={navigateNext}
                disabled={!canNavigateNext}
                className="h-8 w-8 p-0"
                title="Bicicleta siguiente"
                data-testid="nav-next-btn"
              >
                <ChevronRight size={20} />
              </Button>
            </div>
          )}
          
          <div>
            <h1 className="text-4xl font-bold font-['Barlow_Condensed'] tracking-tight text-slate-900">
              {bicycle.model}
            </h1>
            <p className="text-slate-500">
              Código: <span className="font-mono font-semibold text-orange-600">{bicycle.number}</span>
              {bicycle.size && <span> &middot; Talla {bicycle.size}</span>}
            </p>
          </div>
        </div>
        
        <div className="flex flex-wrap gap-2">
          {/* Print Label Button */}
          <Button 
            variant="outline" 
            className="gap-2"
            onClick={() => setIsPrintLabelOpen(true)}
            data-testid="print-label-btn"
          >
            <Printer size={16} />
            Imprimir etiqueta
          </Button>
          
          {/* Edit Button - Admin only */}
          {isAdmin && bicycle.status !== 'vendida' && (
          <Dialog open={isEditDialogOpen} onOpenChange={(open) => {
            setIsEditDialogOpen(open);
            setHasUnsavedChanges(open);
          }}>
            <DialogTrigger asChild>
              <Button variant="outline" className="gap-2" data-testid="edit-bike-btn">
                <Edit size={16} />
                Editar
              </Button>
            </DialogTrigger>
            <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
              <DialogHeader>
                <DialogTitle className="text-xl font-['Barlow_Condensed']">Editar Bicicleta</DialogTitle>
              </DialogHeader>
              <form onSubmit={handleUpdateBicycle} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <Label>Código</Label>
                    <Input
                      value={editData.number}
                      disabled
                      className="bg-slate-50 font-mono text-orange-600"
                      data-testid="edit-number-input"
                    />
                    <p className="text-xs text-slate-400">El código no se puede modificar</p>
                  </div>
                  <div className="space-y-2">
                    <Label>Modelo</Label>
                    <Select
                      value={editData.modelo_id || ''}
                      onValueChange={(v) => {
                        const m = catalogModels.find(cm => cm.id === v);
                        setEditData({...editData, modelo_id: v, model: m ? m.nombre_modelo : editData.model});
                      }}
                    >
                      <SelectTrigger data-testid="edit-modelo-select">
                        <SelectValue placeholder="Seleccionar modelo..." />
                      </SelectTrigger>
                      <SelectContent>
                        {catalogModels.map(m => (
                          <SelectItem key={m.id} value={m.id}>
                            {m.numero_modelo} - {m.nombre_modelo}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                  <div className="space-y-2">
                    <Label>Talla</Label>
                    <Select value={editData.size || ''} onValueChange={(v) => setEditData({...editData, size: v})}>
                      <SelectTrigger data-testid="edit-size-select">
                        <SelectValue placeholder="Seleccionar talla..." />
                      </SelectTrigger>
                      <SelectContent>
                        {editData.size && !catalogTallas.some(t => t.talla === editData.size) && (
                          <SelectItem value={editData.size}>{editData.size} (actual)</SelectItem>
                        )}
                        {catalogTallas.map(t => (
                          <SelectItem key={t.id} value={t.talla}>{t.talla}</SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                    <p className="text-xs text-slate-400">Al cambiarla, el código se actualiza automáticamente</p>
                  </div>
                  <div className="space-y-2">
                    <Label>Estado</Label>
                    <Select value={editData.status} onValueChange={(v) => setEditData({...editData, status: v})}>
                      <SelectTrigger data-testid="edit-status-select">
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="activa">Activa</SelectItem>
                        <SelectItem value="en_taller">En Taller</SelectItem>
                        {isAdmin && <SelectItem value="retirada">Retirada</SelectItem>}
                        {isAdmin && <SelectItem value="robada">Robada</SelectItem>}
                      </SelectContent>
                    </Select>
                  </div>
                </div>
                
                {/* Additional fields - Admin only */}
                {isAdmin && (
                <>
                  <div className="border-t pt-4 mt-4">
                    <h3 className="font-semibold text-slate-700 mb-3">Información Adicional</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <Label>URL Foto</Label>
                        <Input
                          value={editData.photo_url}
                          onChange={(e) => setEditData({...editData, photo_url: e.target.value})}
                          placeholder="https://..."
                          data-testid="edit-photo-input"
                        />
                      </div>
                      <div className="space-y-2">
                        <Label>Categoría (Lokki)</Label>
                        <Input
                          list="lokki-categories"
                          value={editData.category}
                          onChange={(e) => setEditData({...editData, category: e.target.value})}
                          placeholder="Automática por modelo si se deja vacía"
                          data-testid="edit-category-input"
                        />
                        <datalist id="lokki-categories">
                          {catalogCategorias.map(c => <option key={c.id} value={c.nombre} />)}
                        </datalist>
                        {!editData.category && (() => {
                          const m = catalogModels.find(cm => cm.id === editData.modelo_id) || catalogModels.find(cm => cm.nombre_modelo === editData.model);
                          return m?.categoria
                            ? <p className="text-xs text-green-600" data-testid="inherited-category-hint">Heredada del modelo: {m.categoria}</p>
                            : null;
                        })()}
                      </div>
                      <div className="space-y-2">
                        <Label>Nº Bastidor</Label>
                        <Input
                          value={editData.frame_number}
                          onChange={(e) => setEditData({...editData, frame_number: e.target.value})}
                          placeholder="WBS12345..."
                          data-testid="edit-frame-input"
                        />
                      </div>
                      <div className="space-y-2">
                        <Label>Nº Factura</Label>
                        <Input
                          value={editData.invoice_number}
                          onChange={(e) => setEditData({...editData, invoice_number: e.target.value})}
                          placeholder="FAC-001"
                          data-testid="edit-invoice-input"
                        />
                      </div>
                      <div className="space-y-2">
                        <Label>Nº Albarán</Label>
                        <Input
                          value={editData.delivery_note_number}
                          onChange={(e) => setEditData({...editData, delivery_note_number: e.target.value})}
                          placeholder="ALB-001"
                          data-testid="edit-delivery-note-input"
                        />
                      </div>
                      <div className="space-y-2">
                        <Label>Fecha de Compra</Label>
                        <Input
                          type="date"
                          value={editData.purchase_date}
                          onChange={(e) => setEditData({...editData, purchase_date: e.target.value})}
                          data-testid="edit-purchase-date-input"
                        />
                      </div>
                      <div className="space-y-2">
                        <Label>Año del Modelo</Label>
                        <Input
                          type="number"
                          min="2000"
                          max="2100"
                          placeholder="Ej: 2025"
                          value={editData.model_year}
                          onChange={(e) => setEditData({...editData, model_year: e.target.value})}
                          data-testid="edit-model-year-input"
                        />
                        <p className="text-xs text-slate-500">Para cálculo de depreciación en 2ª mano</p>
                      </div>
                      <div className="space-y-2">
                        <Label>Precio de Compra (Neto)</Label>
                        <div className="relative">
                          <Euro className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
                          <Input
                            type="number"
                            step="0.01"
                            className="pl-9"
                            value={editData.purchase_price}
                            onChange={(e) => setEditData({...editData, purchase_price: e.target.value})}
                            placeholder="0.00"
                            data-testid="edit-purchase-price-input"
                          />
                        </div>
                      </div>
                      <div className="space-y-2 flex items-end">
                        <div className="flex items-center space-x-2">
                          <Checkbox 
                            id="warranty"
                            checked={editData.warranty_active}
                            onCheckedChange={(checked) => setEditData({...editData, warranty_active: checked})}
                          />
                          <Label htmlFor="warranty" className="cursor-pointer">Garantía Activa</Label>
                        </div>
                      </div>
                      <div className="space-y-2 flex items-end">
                        <div className="flex items-center space-x-2">
                          <Checkbox 
                            id="is_electric"
                            checked={editData.is_electric}
                            onCheckedChange={(checked) => setEditData({...editData, is_electric: checked})}
                            data-testid="edit-is-electric-checkbox"
                          />
                          <Label htmlFor="is_electric" className="cursor-pointer flex items-center gap-1">
                            <Zap size={14} className="text-yellow-500" />
                            Bicicleta Eléctrica
                          </Label>
                        </div>
                      </div>

                      {/* Cambio electrónico */}
                      <div className="space-y-2 flex items-end">
                        <div className="flex items-center space-x-2">
                          <Checkbox 
                            id="cambio_electronico"
                            checked={editData.cambio_electronico}
                            onCheckedChange={(checked) => setEditData({...editData, cambio_electronico: checked, codigo_bloqueo: checked ? editData.codigo_bloqueo : ''})}
                            data-testid="edit-cambio-electronico-checkbox"
                          />
                          <Label htmlFor="cambio_electronico" className="cursor-pointer flex items-center gap-1">
                            <Zap size={14} className="text-blue-500" />
                            Cambio Electrónico
                          </Label>
                        </div>
                      </div>

                      {editData.cambio_electronico && (
                        <div className="space-y-2">
                          <Label className="flex items-center gap-1">
                            <Lock size={14} className="text-blue-600" />
                            Código de Bloqueo (opcional · 6 dígitos)
                          </Label>
                          <Input
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]{6}"
                            maxLength={6}
                            placeholder="Vacío — los mecánicos podrán rellenarlo desde Componentes"
                            value={editData.codigo_bloqueo}
                            onChange={(e) => {
                              const val = e.target.value.replace(/\D/g, '').slice(0, 6);
                              setEditData({...editData, codigo_bloqueo: val});
                            }}
                            data-testid="edit-codigo-bloqueo-input"
                            className="font-mono tracking-widest text-lg"
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Components section */}
                  <div className="border-t pt-4 mt-4">
                    <h3 className="font-semibold text-slate-700 mb-3 flex items-center gap-2">
                      <Cog size={16} /> Componentes
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div className="space-y-2">
                        <Label className="flex items-center gap-2">
                          <Palette size={14} className="text-purple-600" />
                          Color
                        </Label>
                        <Combobox
                          options={componentOptions.colors}
                          value={editData.color}
                          onChange={(val) => setEditData({...editData, color: val})}
                          placeholder="Seleccionar color..."
                          emptyText="Sin colores previos"
                          allowDelete={isAdmin}
                          onDeleteOption={(val) => handleDeleteComponentOption('color', val)}
                          data-testid="edit-color-combobox"
                        />
                      </div>
                      <div className="space-y-2">
                        <Label className="flex items-center gap-2">
                          <Circle size={14} className="text-blue-600" />
                          Ruedas
                        </Label>
                        <Combobox
                          options={componentOptions.wheels}
                          value={editData.wheels}
                          onChange={(val) => setEditData({...editData, wheels: val})}
                          placeholder="Seleccionar ruedas..."
                          emptyText="Sin ruedas previas"
                          allowDelete={isAdmin}
                          onDeleteOption={(val) => handleDeleteComponentOption('wheels', val)}
                          data-testid="edit-wheels-combobox"
                        />
                      </div>
                      <div className="space-y-2">
                        <Label className="flex items-center gap-2">
                          <Cog size={14} className="text-orange-600" />
                          Grupo
                        </Label>
                        <Combobox
                          options={componentOptions.groupsets}
                          value={editData.groupset}
                          onChange={(val) => setEditData({...editData, groupset: val})}
                          placeholder="Seleccionar grupo..."
                          emptyText="Sin grupos previos"
                          allowDelete={isAdmin}
                          onDeleteOption={(val) => handleDeleteComponentOption('groupset', val)}
                          data-testid="edit-groupset-combobox"
                        />
                      </div>
                    </div>
                    
                    {/* Custom Components Section */}
                    <div className="mt-4 pt-4 border-t border-dashed border-slate-200">
                      <h4 className="text-sm font-semibold text-slate-600 mb-3 flex items-center gap-2">
                        <Plus size={14} />
                        Componentes Personalizados
                      </h4>
                      
                      {/* Existing custom components */}
                      {editData.custom_components && Object.keys(editData.custom_components).length > 0 && (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 mb-4">
                          {Object.entries(editData.custom_components).map(([name, value]) => (
                            <div key={name} className="flex items-center gap-2 bg-slate-50 rounded-lg p-2 border border-slate-200">
                              <div className="flex-1 min-w-0">
                                <Label className="text-xs text-slate-500 capitalize">{name}</Label>
                                <Input
                                  value={value}
                                  onChange={(e) => handleUpdateCustomComponent(name, e.target.value)}
                                  className="h-8 text-sm"
                                  placeholder={`Valor de ${name}`}
                                />
                              </div>
                              <Button
                                type="button"
                                variant="ghost"
                                size="sm"
                                onClick={() => handleRemoveCustomComponent(name)}
                                className="text-red-500 hover:text-red-700 hover:bg-red-50 h-8 w-8 p-0 flex-shrink-0"
                              >
                                <Trash2 size={14} />
                              </Button>
                            </div>
                          ))}
                        </div>
                      )}
                      
                      {/* Add new custom component */}
                      <div className="flex gap-2 items-end bg-blue-50 rounded-lg p-3 border border-blue-200">
                        <div className="flex-1">
                          <Label className="text-xs text-blue-700">Nombre del componente</Label>
                          <Input
                            value={newComponent.name}
                            onChange={(e) => setNewComponent({...newComponent, name: e.target.value})}
                            placeholder="Ej: Sillín, Potencia, Pedales..."
                            className="h-9"
                            data-testid="new-component-name"
                          />
                        </div>
                        <div className="flex-1">
                          <Label className="text-xs text-blue-700">Valor</Label>
                          <Input
                            value={newComponent.value}
                            onChange={(e) => setNewComponent({...newComponent, value: e.target.value})}
                            placeholder="Ej: Fizik Antares, 110mm..."
                            className="h-9"
                            data-testid="new-component-value"
                          />
                        </div>
                        <Button
                          type="button"
                          onClick={handleAddCustomComponent}
                          className="bg-blue-600 hover:bg-blue-700 h-9"
                          data-testid="add-custom-component-btn"
                        >
                          <Plus size={16} />
                        </Button>
                      </div>
                      <p className="text-xs text-slate-500 mt-2">
                        Añade componentes adicionales como: Sillín, Potencia, Pedales, Horquilla, Motor, etc.
                      </p>
                    </div>
                  </div>
                </>
                )}
                
                <DialogFooter>
                  <Button type="submit" className="bg-orange-500 hover:bg-orange-600 text-white" data-testid="save-edit-btn">
                    Guardar Cambios
                  </Button>
                </DialogFooter>
              </form>
            </DialogContent>
          </Dialog>
          )}

          {/* Sell Button - Admin only, non-sold bikes */}
          {isAdmin && bicycle.status !== 'vendida' && (
          <Dialog open={isSellDialogOpen} onOpenChange={(open) => {
            setIsSellDialogOpen(open);
            if (open && bicycle.model && bicycle.model_year) {
              axios.get(`${API}/model-pricing/suggest?model_name=${encodeURIComponent(bicycle.model)}&year=${bicycle.model_year}`)
                .then(res => { if (res.data.found) setSuggestedPrice(res.data.price); else setSuggestedPrice(null); })
                .catch(() => setSuggestedPrice(null));
            }
          }}>
            <DialogTrigger asChild>
              <Button variant="outline" className="gap-2 text-green-600 border-green-200 hover:bg-green-50" data-testid="sell-bike-btn">
                <ShoppingCart size={16} />
                Vender
              </Button>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader>
                <DialogTitle className="text-xl font-['Barlow_Condensed']">Registrar Venta</DialogTitle>
              </DialogHeader>
              <form onSubmit={handleSellBicycle} className="space-y-4">
                <div className="bg-slate-50 p-4 rounded-lg space-y-2">
                  <p className="text-sm text-slate-600">
                    <strong>Precio compra:</strong> {formatCurrency(bicycle.purchase_price || 0)}
                  </p>
                  <p className="text-sm text-slate-600">
                    <strong>Gastos mantenimiento:</strong> {formatCurrency(bicycle.total_maintenance_cost || 0)}
                  </p>
                  <p className="text-sm font-semibold text-slate-800">
                    <strong>Total invertido:</strong> {formatCurrency((bicycle.purchase_price || 0) + (bicycle.total_maintenance_cost || 0))}
                  </p>
                  {suggestedPrice && (
                    <div className="mt-2 pt-2 border-t border-slate-200 flex items-center justify-between">
                      <p className="text-sm text-blue-700">
                        <strong>Precio sugerido ({bicycle.model} {bicycle.model_year}):</strong> {formatCurrency(suggestedPrice)}
                      </p>
                      <Button type="button" size="sm" variant="outline" className="h-7 text-xs text-blue-600 border-blue-300"
                        onClick={() => setSellData({ ...sellData, sold_price: suggestedPrice.toString() })}
                        data-testid="use-suggested-price-btn">
                        Usar precio
                      </Button>
                    </div>
                  )}
                </div>
                
                <div className="space-y-2">
                  <Label>Vendido a (opcional)</Label>
                  <Input
                    type="text"
                    value={sellData.sold_to}
                    onChange={(e) => setSellData({...sellData, sold_to: e.target.value})}
                    placeholder="Nombre del comprador"
                    data-testid="sold-to-input"
                  />
                </div>
                
                <div className="space-y-2">
                  <Label>Precio de Venta (Neto)</Label>
                  <div className="relative">
                    <Euro className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
                    <Input
                      type="number"
                      step="0.01"
                      className="pl-9"
                      value={sellData.sold_price}
                      onChange={(e) => setSellData({...sellData, sold_price: e.target.value})}
                      placeholder="0.00"
                      required
                      data-testid="sell-price-input"
                    />
                  </div>
                </div>
                
                <div className="space-y-2">
                  <Label>Ingresos por Alquiler (Total generado)</Label>
                  <div className="relative">
                    <Euro className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
                    <Input
                      type="number"
                      step="0.01"
                      className="pl-9"
                      value={sellData.rental_income}
                      onChange={(e) => setSellData({...sellData, rental_income: e.target.value})}
                      placeholder="0.00"
                      data-testid="rental-income-input"
                    />
                  </div>
                  <p className="text-xs text-slate-500">Introduce el total de ingresos generados por el alquiler de esta bicicleta</p>
                </div>

                <div className="border border-orange-200 bg-orange-50/60 rounded-lg p-3 space-y-2">
                  <div className="flex items-center justify-between">
                    <Label className="text-sm font-medium text-orange-900">Importe cobrado ahora</Label>
                    <Button type="button" size="sm" variant="outline" className="h-7 px-3 text-xs bg-white !text-green-700 border-green-300 hover:bg-green-50"
                      onClick={() => setSellData({ ...sellData, amount_paid: sellData.sold_price })}
                      disabled={!sellData.sold_price}
                      data-testid="full-payment-btn">
                      Cobro completo
                    </Button>
                  </div>
                  <div className="relative">
                    <Euro className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
                    <Input
                      type="number"
                      step="0.01"
                      min="0"
                      className="pl-9 bg-white"
                      value={sellData.amount_paid}
                      onChange={(e) => setSellData({ ...sellData, amount_paid: e.target.value })}
                      placeholder="0.00"
                      data-testid="amount-paid-input"
                    />
                  </div>
                  {(() => {
                    const pend = Math.max(0, (parseFloat(sellData.sold_price) || 0) - (parseFloat(sellData.amount_paid) || 0));
                    return pend > 0 ? (
                      <p className="text-xs text-orange-800" data-testid="sell-pending-info">
                        Quedará <strong>pendiente de cobro: {formatCurrency(pend)}</strong>. La bicicleta sale del inventario y aparecerá en "Vendidas pendiente de cobro".
                      </p>
                    ) : (
                      <p className="text-xs text-green-700" data-testid="sell-paid-info">Venta cobrada íntegramente.</p>
                    );
                  })()}
                </div>

                <div className="bg-orange-50 p-4 rounded-lg">
                  <p className="text-sm text-orange-800">
                    <strong>Beneficio estimado:</strong>{' '}
                    {formatCurrency(
                      (parseFloat(sellData.sold_price) || 0) + 
                      (parseFloat(sellData.rental_income) || 0) - 
                      ((bicycle.purchase_price || 0) + (bicycle.total_maintenance_cost || 0))
                    )}
                  </p>
                </div>
                
                <DialogFooter>
                  <Button type="submit" className="bg-green-600 hover:bg-green-700 text-white" data-testid="confirm-sell-btn">
                    Confirmar Venta
                  </Button>
                </DialogFooter>
              </form>
            </DialogContent>
          </Dialog>
          )}

          {/* Reactivate Button - Admin only, sold bikes */}
          {isAdmin && bicycle.status === 'vendida' && (
          <Dialog open={isReactivateOpen} onOpenChange={setIsReactivateOpen}>
            <DialogTrigger asChild>
              <Button variant="outline" className="gap-2 text-blue-600 border-blue-200 hover:bg-blue-50" data-testid="reactivate-bike-btn">
                <RefreshCw size={16} />
                Reactivar
              </Button>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>Reactivar Bicicleta</DialogTitle>
              </DialogHeader>
              <form onSubmit={handleReactivate} className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg text-sm text-blue-800">
                  <p>Se iniciará un <strong>nuevo ciclo de vida</strong> para esta bicicleta.</p>
                  <p className="mt-1">Los datos del ciclo anterior se conservarán en el historial.</p>
                  {bicycle.lifecycle_id > 0 && (
                    <p className="mt-1 font-medium">Ciclo actual: #{bicycle.lifecycle_id || 1}</p>
                  )}
                </div>
                <div className="space-y-2">
                  <Label>Nuevo precio de compra / recompra</Label>
                  <div className="relative">
                    <Euro className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
                    <Input type="number" step="0.01" className="pl-9" value={reactivatePrice}
                      onChange={(e) => setReactivatePrice(e.target.value)} placeholder="0.00" required
                      data-testid="reactivate-price-input" />
                  </div>
                </div>
                <DialogFooter>
                  <Button type="submit" className="bg-blue-600 hover:bg-blue-700 text-white" data-testid="confirm-reactivate-btn">
                    Confirmar Reactivación
                  </Button>
                </DialogFooter>
              </form>
            </DialogContent>
          </Dialog>
          )}

          {/* Add Revision - Only if not sold */}
          {bicycle.status !== 'vendida' && (
          <Dialog open={isRevisionDialogOpen} onOpenChange={setIsRevisionDialogOpen}>
            <DialogTrigger asChild>
              <Button className="bg-orange-500 hover:bg-orange-600 text-white gap-2" data-testid="add-revision-btn">
                <Plus size={18} />
                Añadir Revisión
              </Button>
            </DialogTrigger>
            <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
              <DialogHeader>
                <DialogTitle className="text-xl font-['Barlow_Condensed']">Nueva Revisión</DialogTitle>
              </DialogHeader>
              <form onSubmit={handleAddRevision} className="space-y-4">
                <div className="space-y-2">
                  <Label>Descripción del trabajo</Label>
                  <Textarea
                    placeholder="Describe el trabajo realizado..."
                    value={newRevision.description}
                    onChange={(e) => setNewRevision({...newRevision, description: e.target.value})}
                    required
                    rows={3}
                    data-testid="revision-description-input"
                  />
                </div>

                {/* Kilometers field - only for electric bikes */}
                {bicycle?.is_electric && (
                  <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                    <Label className="flex items-center gap-2 text-yellow-700 font-semibold mb-2">
                      <Zap size={16} className="text-yellow-600" />
                      Kilómetros Actuales (Bicicleta Eléctrica)
                    </Label>
                    <div className="flex items-center gap-3">
                      <div className="flex-1">
                        <Input
                          type="number"
                          placeholder="Ej: 1250"
                          value={revisionKm}
                          onChange={(e) => setRevisionKm(e.target.value)}
                          min="0"
                          className="bg-white"
                          data-testid="revision-km-input"
                        />
                      </div>
                      <span className="text-sm text-yellow-600 font-medium">km</span>
                    </div>
                    {bicycle?.last_km !== null && bicycle?.last_km !== undefined && (
                      <p className="text-xs text-yellow-600 mt-2 flex items-center gap-1">
                        <Gauge size={12} />
                        Último registro: {bicycle.last_km.toLocaleString()} km
                      </p>
                    )}
                  </div>
                )}

                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <Label>Materiales utilizados</Label>
                    <Button 
                      type="button" 
                      variant="outline" 
                      size="sm"
                      onClick={handleAddMaterial}
                      className="gap-1"
                      data-testid="add-material-btn"
                    >
                      <Plus size={14} />
                      Añadir Material
                    </Button>
                  </div>

                  {newRevision.materials.length === 0 ? (
                    <p className="text-sm text-slate-400 text-center py-4">
                      No se han añadido materiales
                    </p>
                  ) : (
                    <div className="space-y-3">
                      {newRevision.materials.map((mat, index) => {
                        const categories = [...new Set(materials.map(m => m.category || 'Sin categoría'))];
                        const selectedCategory = materialFilters[index] || 'all';
                        const filteredMaterials = selectedCategory === 'all' 
                          ? materials 
                          : materials.filter(m => (m.category || 'Sin categoría') === selectedCategory);
                        
                        return (
                        <div key={index} className="bg-slate-50 p-3 rounded-lg space-y-2">
                          <div className="flex gap-2 items-end">
                            <div className="w-40">
                              <Label className="text-xs">Categoría</Label>
                              <Select 
                                value={selectedCategory}
                                onValueChange={(v) => setMaterialFilters({...materialFilters, [index]: v})}
                              >
                                <SelectTrigger data-testid={`category-filter-${index}`}>
                                  <SelectValue placeholder="Filtrar..." />
                                </SelectTrigger>
                                <SelectContent>
                                  <SelectItem value="all">Todas</SelectItem>
                                  {categories.map(cat => (
                                    <SelectItem key={cat} value={cat}>{cat}</SelectItem>
                                  ))}
                                </SelectContent>
                              </Select>
                            </div>
                            <div className="flex-1 min-w-[250px]">
                              <Label className="text-xs">Material</Label>
                              <Select 
                                value={mat.material_id} 
                                onValueChange={(v) => handleMaterialChange(index, 'material_id', v)}
                              >
                                <SelectTrigger data-testid={`material-select-${index}`} className="w-full">
                                  <SelectValue placeholder="Seleccionar..." />
                                </SelectTrigger>
                                <SelectContent className="max-w-[400px]">
                                  {filteredMaterials.map(m => (
                                    <SelectItem key={m.id} value={m.id}>
                                      {m.name} - {formatCurrency(m.price)}
                                    </SelectItem>
                                  ))}
                                </SelectContent>
                              </Select>
                            </div>
                            <div className="w-20">
                              <Label className="text-xs">Cant.</Label>
                              <Input
                                type="number"
                                min="1"
                                step="1"
                                value={mat.quantity}
                                onChange={(e) => handleMaterialChange(index, 'quantity', Math.floor(Number(e.target.value)) || 1)}
                                data-testid={`material-qty-${index}`}
                              />
                            </div>
                            <div className="w-28">
                              <Label className="text-xs">Total</Label>
                              <div className="h-10 px-3 flex items-center bg-white border rounded-md text-sm font-medium">
                                {formatCurrency(mat.total_price)}
                              </div>
                            </div>
                            <Button
                              type="button"
                              variant="ghost"
                              size="icon"
                              onClick={() => handleRemoveMaterial(index)}
                              className="text-red-500 hover:text-red-600"
                            >
                              <Trash2 size={16} />
                            </Button>
                          </div>
                        </div>
                        );
                      })}
                    </div>
                  )}

                  {newRevision.materials.length > 0 && (
                    <div className="flex justify-end pt-2 border-t">
                      <div className="text-right">
                        <span className="text-sm text-slate-500">Total revisión: </span>
                        <span className="text-lg font-bold text-slate-900">{formatCurrency(totalRevisionCost)}</span>
                      </div>
                    </div>
                  )}
                </div>

                <DialogFooter>
                  <Button type="submit" className="bg-orange-500 hover:bg-orange-600 text-white" data-testid="save-revision-btn">
                    Guardar Revisión
                  </Button>
                </DialogFooter>
              </form>
            </DialogContent>
          </Dialog>
          )}
        </div>
      </div>

      {/* Photo & Components Section - Visible for all users */}
      <Card className="border-slate-200" data-testid="bicycle-photo-section">
        <CardContent className="p-6">
          <div className="flex flex-col lg:flex-row gap-6">
            {/* Photo Display */}
            <div className="flex-shrink-0">
              {bicycle.photo_url && !imageError && getImageUrl(bicycle.photo_url) ? (
                <div className="relative group">
                  {imageLoading && (
                    <div className="absolute inset-0 w-48 h-48 bg-slate-100 rounded-xl flex items-center justify-center border-2 border-slate-200 z-10">
                      <div className="text-center">
                        <RefreshCw size={24} className="mx-auto text-slate-400 mb-2 animate-spin" />
                        <p className="text-xs text-slate-500">Cargando...</p>
                      </div>
                    </div>
                  )}
                  <img 
                    src={getImageUrl(bicycle.photo_url)}
                    alt={`Bicicleta ${bicycle.number || 'sin número'}`}
                    className="w-48 h-48 object-contain rounded-xl border-2 border-slate-200 shadow-sm bg-slate-50"
                    onLoad={() => setImageLoading(false)}
                    onError={(e) => {
                      console.warn('Image load error for:', bicycle.photo_url);
                      e.target.onerror = null; // Prevent infinite loop
                      setImageLoading(false);
                      setImageError(true);
                    }}
                  />
                </div>
              ) : bicycle.photo_url ? (
                // Error state or URL generation failed - show placeholder
                <div className="w-48 h-48 relative">
                  <div className="w-full h-full bg-gradient-to-br from-slate-100 to-slate-200 rounded-xl flex items-center justify-center border-2 border-slate-200">
                    <div className="text-center">
                      <Bike size={48} className="mx-auto text-slate-300 mb-2" />
                      <p className="text-xs text-slate-400">Imagen no disponible</p>
                    </div>
                  </div>
                  {/* Retry/Upload overlay on hover */}
                  {isAdmin && (
                    <div className="absolute inset-0 bg-black/50 rounded-xl opacity-0 hover:opacity-100 transition-opacity flex items-center justify-center">
                      <div className="text-center space-y-2">
                        {imageRetryCount < 3 && (
                          <Button 
                            variant="secondary" 
                            size="sm" 
                            onClick={handleImageRetry}
                            className="text-xs gap-1"
                          >
                            <RefreshCw size={12} />
                            Reintentar
                          </Button>
                        )}
                        <label className="cursor-pointer block">
                          <input
                            type="file"
                            accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp"
                            onChange={handlePhotoUpload}
                            className="hidden"
                          />
                          <Button 
                            variant="default" 
                            size="sm" 
                            className="text-xs gap-1 w-full"
                            asChild
                          >
                            <span>
                              <Upload size={12} />
                              Subir nueva
                            </span>
                          </Button>
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="w-48 h-48 bg-slate-100 rounded-xl flex items-center justify-center border-2 border-dashed border-slate-300">
                  <div className="text-center">
                    <Camera size={32} className="mx-auto text-slate-400 mb-2" />
                    <p className="text-sm text-slate-500">Sin foto</p>
                  </div>
                </div>
              )}
              
              {/* Upload Button - Admin only, below photo (only if no error state) */}
              {isAdmin && bicycle.status !== 'vendida' && !imageError && (
                <div className="mt-3">
                  <input
                    type="file"
                    id="photo-upload"
                    accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp"
                    onChange={handlePhotoUpload}
                    className="hidden"
                    data-testid="photo-upload-input"
                  />
                  <label htmlFor="photo-upload" className="block">
                    <Button 
                      type="button"
                      variant="outline" 
                      size="sm"
                      className="gap-2 cursor-pointer w-full"
                      disabled={uploadingPhoto}
                      asChild
                    >
                      <span>
                        {uploadingPhoto ? (
                          <>
                            <div className="spinner w-4 h-4" />
                            Subiendo...
                          </>
                        ) : (
                          <>
                            <Upload size={14} />
                            {bicycle.photo_url ? 'Cambiar' : 'Subir Foto'}
                          </>
                        )}
                      </span>
                    </Button>
                  </label>
                </div>
              )}
            </div>

            {/* Components Section */}
            <div className="flex-1 bg-slate-50 rounded-xl p-4 border border-slate-200">
              <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wide mb-4">
                Componentes
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {/* Color */}
                <div className="flex items-center gap-3 bg-white rounded-lg p-3 shadow-sm border border-slate-100">
                  <div className="w-10 h-10 bg-gradient-to-br from-pink-100 to-purple-100 rounded-lg flex items-center justify-center">
                    <Palette size={20} className="text-purple-600" />
                  </div>
                  <div>
                    <p className="text-xs text-slate-400 uppercase tracking-wide">Color</p>
                    <p className="font-medium text-slate-800">
                      {bicycle.color || <span className="text-slate-400 italic">Sin definir</span>}
                    </p>
                  </div>
                </div>

                {/* Ruedas - Bicycle Wheel Icon */}
                <div className="flex items-center gap-3 bg-white rounded-lg p-3 shadow-sm border border-slate-100">
                  <div className="w-10 h-10 bg-gradient-to-br from-blue-100 to-cyan-100 rounded-lg flex items-center justify-center">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" className="text-blue-600">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
                      <line x1="12" y1="2" x2="12" y2="9" stroke="currentColor" strokeWidth="1.5"/>
                      <line x1="12" y1="15" x2="12" y2="22" stroke="currentColor" strokeWidth="1.5"/>
                      <line x1="2" y1="12" x2="9" y2="12" stroke="currentColor" strokeWidth="1.5"/>
                      <line x1="15" y1="12" x2="22" y2="12" stroke="currentColor" strokeWidth="1.5"/>
                      <line x1="4.93" y1="4.93" x2="9.17" y2="9.17" stroke="currentColor" strokeWidth="1.5"/>
                      <line x1="14.83" y1="14.83" x2="19.07" y2="19.07" stroke="currentColor" strokeWidth="1.5"/>
                      <line x1="4.93" y1="19.07" x2="9.17" y2="14.83" stroke="currentColor" strokeWidth="1.5"/>
                      <line x1="14.83" y1="9.17" x2="19.07" y2="4.93" stroke="currentColor" strokeWidth="1.5"/>
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs text-slate-400 uppercase tracking-wide">Ruedas</p>
                    <p className="font-medium text-slate-800">
                      {bicycle.wheels || <span className="text-slate-400 italic">Sin definir</span>}
                    </p>
                  </div>
                </div>

                {/* Grupo - Rear Derailleur Icon */}
                <div className="flex items-center gap-3 bg-white rounded-lg p-3 shadow-sm border border-slate-100">
                  <div className="w-10 h-10 bg-gradient-to-br from-amber-100 to-orange-100 rounded-lg flex items-center justify-center">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" className="text-orange-600">
                      {/* Rear derailleur shape */}
                      <circle cx="8" cy="6" r="3" stroke="currentColor" strokeWidth="2"/>
                      <circle cx="16" cy="18" r="4" stroke="currentColor" strokeWidth="2"/>
                      <circle cx="8" cy="18" r="2.5" stroke="currentColor" strokeWidth="2"/>
                      <path d="M8 9 L8 15.5" stroke="currentColor" strokeWidth="2"/>
                      <path d="M10.5 17 L12 17" stroke="currentColor" strokeWidth="2"/>
                      <path d="M11 6 L14 10 L14 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs text-slate-400 uppercase tracking-wide">Grupo</p>
                    <p className="font-medium text-slate-800">
                      {bicycle.groupset || <span className="text-slate-400 italic">Sin definir</span>}
                    </p>
                  </div>
                </div>

                {/* Electric indicator - only show if is_electric */}
                {bicycle.is_electric && (
                  <div className="flex items-center gap-3 bg-gradient-to-r from-yellow-50 to-amber-50 rounded-lg p-3 shadow-sm border border-yellow-200">
                    <div className="w-10 h-10 bg-gradient-to-br from-yellow-200 to-amber-200 rounded-lg flex items-center justify-center">
                      <Zap size={20} className="text-yellow-600" />
                    </div>
                    <div>
                      <p className="text-xs text-yellow-600 uppercase tracking-wide font-semibold">Tipo</p>
                      <p className="font-semibold text-yellow-700">
                        Bicicleta Eléctrica
                      </p>
                      {bicycle.last_km !== null && bicycle.last_km !== undefined && (
                        <p className="text-xs text-yellow-600 mt-0.5 flex items-center gap-1">
                          <Gauge size={12} />
                          Último registro: {bicycle.last_km.toLocaleString()} km
                        </p>
                      )}
                    </div>
                  </div>
                )}

                {/* Cambio electrónico — display now lives inside Custom Components below
                    (rendered via the PIN-editable component for "PIN cambio electrónico" key). */}

                {/* Custom Components */}
                {bicycle.custom_components && Object.keys(bicycle.custom_components).length > 0 && (
                  Object.entries(bicycle.custom_components).map(([name, value]) => {
                    const isPin = name === 'PIN cambio electrónico';
                    return (
                      <div
                        key={name}
                        className={`flex items-center gap-3 rounded-lg p-3 shadow-sm border ${
                          isPin
                            ? 'bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-200'
                            : 'bg-white border-slate-100'
                        }`}
                      >
                        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                          isPin
                            ? 'bg-gradient-to-br from-blue-200 to-indigo-200'
                            : 'bg-gradient-to-br from-slate-100 to-slate-200'
                        }`}>
                          {isPin ? <Lock size={20} className="text-blue-600" /> : <Cog size={20} className="text-slate-500" />}
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className={`text-xs uppercase tracking-wide capitalize ${isPin ? 'text-blue-600 font-semibold' : 'text-slate-400'}`}>
                            {name}
                          </p>
                          {isPin ? (
                            <ComponentsPinEditor
                              bicycleId={bicycle.id}
                              initial={value || ''}
                              onSaved={fetchBicycle}
                            />
                          ) : (
                            <p className="font-medium text-slate-800">
                              {value || <span className="text-slate-400 italic">Sin definir</span>}
                            </p>
                          )}
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Status and Revision Section */}
      <Card className={`border-2 ${
        bicycle.status === 'rota' ? 'border-red-300 bg-red-50' : 
        bicycle.status === 'en revisión' ? 'border-yellow-300 bg-yellow-50' : 
        bicycle.status === 'prestada' ? 'border-purple-300 bg-purple-50' :
        bicycle.revision_overdue ? 'border-amber-300 bg-amber-50' : 'border-slate-200'
      }`} data-testid="status-section">
        <CardContent className="p-4">
          {/* Two column layout */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            
            {/* LEFT COLUMN: Status, actions, incident comment */}
            <div className="p-4 bg-white border border-slate-200 rounded-lg flex flex-col h-full">
              <h4 className="text-sm font-bold text-slate-700 mb-3 uppercase tracking-wide flex items-center gap-2">
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                  bicycle.status === 'rota' ? 'bg-red-200' : 
                  bicycle.status === 'en revisión' ? 'bg-yellow-200' : 
                  bicycle.status === 'prestada' ? 'bg-purple-200' :
                  'bg-green-100'
                }`}>
                  {bicycle.status === 'rota' ? <AlertTriangle size={16} className="text-red-600" /> 
                    : bicycle.status === 'en revisión' ? <RefreshCw size={16} className="text-yellow-600" />
                    : bicycle.status === 'prestada' ? <UserCheck size={16} className="text-purple-600" />
                    : <Bike size={16} className="text-green-600" />}
                </div>
                Estado de la Bicicleta
              </h4>
              
              {/* Current status display */}
              <div className="flex items-center justify-between mb-3">
                <div>
                  <p className={`text-lg font-bold capitalize ${
                    bicycle.status === 'rota' ? 'text-red-700' : 
                    bicycle.status === 'en revisión' ? 'text-yellow-700' : 
                    bicycle.status === 'prestada' ? 'text-purple-700' :
                    'text-green-700'
                  }`}>
                    {bicycle.status}
                  </p>
                  {bicycle.status_comment && (
                    <p className="text-sm text-slate-600 mt-0.5">{bicycle.status_comment}</p>
                  )}
                </div>
                {bicycle.revision_overdue && (
                  <div className="flex items-center gap-1 bg-amber-100 px-2 py-1 rounded text-amber-700 text-xs font-medium">
                    <Clock size={14} />
                    {bicycle.days_since_revision != null ? `${bicycle.days_since_revision} días` : 'Sin revisiones'}
                  </div>
                )}
                {bicycle.days_since_revision != null && !bicycle.revision_overdue && (
                  <span className="text-xs text-slate-400">
                    Última: hace {bicycle.days_since_revision} días
                  </span>
                )}
              </div>
              
              {/* Loan info display */}
              {bicycle.status === 'prestada' && bicycle.loan_person_name && (
                <div className={`mb-3 p-2 rounded-lg text-sm ${
                  bicycle.loan_return_date && bicycle.loan_return_date < new Date().toISOString().split('T')[0]
                    ? 'bg-red-100 border border-red-300'
                    : bicycle.loan_return_date && bicycle.loan_return_date === new Date().toISOString().split('T')[0]
                      ? 'bg-amber-100 border border-amber-300'
                      : 'bg-purple-100'
                }`}>
                  <p className="font-medium text-purple-800">
                    <User size={14} className="inline mr-1" />
                    {bicycle.loan_person_name}
                  </p>
                  {bicycle.loan_date && (
                    <p className="text-purple-600 text-xs mt-1">
                      <Calendar size={12} className="inline mr-1" />
                      Desde: {new Date(bicycle.loan_date).toLocaleDateString('es-ES')}
                    </p>
                  )}
                  {bicycle.loan_return_date && (() => {
                    const today = new Date().toISOString().split('T')[0];
                    const isOverdue = bicycle.loan_return_date < today;
                    const isDueToday = bicycle.loan_return_date === today;
                    return (
                      <p className={`text-xs mt-1 font-semibold ${isOverdue ? 'text-red-700' : isDueToday ? 'text-amber-700' : 'text-purple-600'}`}>
                        <Calendar size={12} className="inline mr-1" />
                        Devolución: {new Date(bicycle.loan_return_date + 'T00:00:00').toLocaleDateString('es-ES')}
                        {isOverdue && ' — VENCIDO'}
                        {isDueToday && ' — HOY'}
                      </p>
                    );
                  })()}
                  {bicycle.loan_comment && (
                    <p className="text-purple-600 text-xs mt-1 italic">"{bicycle.loan_comment}"</p>
                  )}
                </div>
              )}
              
              {/* Status change buttons */}
              {bicycle.status !== 'vendida' && (
                <div className="flex flex-wrap gap-2 mb-3">
                  {bicycle.status !== 'activa' && (
                    <Button size="sm" variant="outline" className="text-green-600 border-green-300 hover:bg-green-50"
                      onClick={() => handleStatusChange('activa')} disabled={statusChanging} data-testid="status-activa-btn">
                      Activa
                    </Button>
                  )}
                  {bicycle.status !== 'en revisión' && (
                    <Button size="sm" variant="outline" className="text-yellow-600 border-yellow-300 hover:bg-yellow-50"
                      onClick={() => handleStatusChange('en revisión')} disabled={statusChanging} data-testid="status-revision-btn">
                      En revisión
                    </Button>
                  )}
                  {bicycle.status !== 'rota' && (
                    <Button size="sm" variant="outline" className="text-red-600 border-red-300 hover:bg-red-50"
                      onClick={() => handleStatusChange('rota')} disabled={statusChanging} data-testid="status-rota-btn">
                      Rota
                    </Button>
                  )}
                  {bicycle.status !== 'prestada' && (
                    <Button size="sm" variant="outline" className="text-purple-600 border-purple-300 hover:bg-purple-50"
                      disabled={statusChanging} data-testid="status-prestada-btn"
                      onClick={() => document.getElementById('loan-form')?.scrollIntoView({ behavior: 'smooth' })}>
                      Prestar
                    </Button>
                  )}
                  {bicycle.status !== 'robada' && isAdmin && (
                    <Button size="sm" variant="outline" className="text-red-700 border-red-400 hover:bg-red-50"
                      disabled={statusChanging} data-testid="status-robada-btn"
                      onClick={() => document.getElementById('stolen-form')?.scrollIntoView({ behavior: 'smooth' })}>
                      Robada
                    </Button>
                  )}
                </div>
              )}
              
              {/* Loan form */}
              {bicycle.status !== 'vendida' && bicycle.status !== 'prestada' && (
                <div id="loan-form" className="p-3 bg-purple-50 border border-purple-200 rounded-lg mb-3">
                  <h5 className="text-xs font-semibold text-purple-800 mb-2 flex items-center gap-1">
                    <UserCheck size={14} />
                    Prestar bicicleta
                  </h5>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    <div>
                      <Label className="text-xs text-purple-700">Nombre *</Label>
                      <Input
                        value={loanPersonName}
                        onChange={(e) => setLoanPersonName(e.target.value)}
                        placeholder="Nombre completo"
                        className="text-sm h-8"
                        data-testid="loan-person-input"
                      />
                    </div>
                    <div>
                      <Label className="text-xs text-purple-700">Fecha préstamo</Label>
                      <Input
                        type="date"
                        value={loanDate}
                        onChange={(e) => setLoanDate(e.target.value)}
                        className="text-sm h-8"
                        data-testid="loan-date-input"
                      />
                    </div>
                    <div>
                      <Label className="text-xs text-purple-700">Fecha devolución</Label>
                      <Input
                        type="date"
                        value={loanReturnDate}
                        onChange={(e) => setLoanReturnDate(e.target.value)}
                        placeholder="Opcional"
                        className="text-sm h-8"
                        data-testid="loan-return-date-input"
                      />
                    </div>
                    <div>
                      <Label className="text-xs text-purple-700">Nota</Label>
                      <Input
                        value={loanComment}
                        onChange={(e) => setLoanComment(e.target.value)}
                        placeholder="Opcional"
                        className="text-sm h-8"
                        data-testid="loan-comment-input"
                      />
                    </div>
                  </div>
                  <Button 
                    size="sm" 
                    className="mt-2 bg-purple-600 hover:bg-purple-700 h-8"
                    onClick={() => handleStatusChange('prestada')}
                    disabled={statusChanging || !loanPersonName.trim()}
                    data-testid="confirm-loan-btn"
                  >
                    {statusChanging ? 'Procesando...' : 'Confirmar préstamo'}
                  </Button>
                </div>
              )}
              
              {/* Stolen form */}
              {bicycle.status !== 'vendida' && bicycle.status !== 'robada' && isAdmin && (
                <div id="stolen-form" className="p-3 bg-red-50 border border-red-200 rounded-lg mb-3">
                  <h5 className="text-xs font-semibold text-red-800 mb-2">Reportar robo</h5>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    <div>
                      <Label className="text-xs text-red-700">Fecha del robo</Label>
                      <Input type="date" value={stolenDate} onChange={(e) => setStolenDate(e.target.value)}
                        className="text-sm h-8" data-testid="stolen-date-input" />
                    </div>
                    <div>
                      <Label className="text-xs text-red-700">Notas</Label>
                      <Input value={stolenNotes} onChange={(e) => setStolenNotes(e.target.value)}
                        placeholder="Detalles del robo" className="text-sm h-8" data-testid="stolen-notes-input" />
                    </div>
                  </div>
                  <Button size="sm" className="mt-2 bg-red-600 hover:bg-red-700 h-8"
                    onClick={() => handleStatusChange('robada')} disabled={statusChanging}
                    data-testid="confirm-stolen-btn">
                    {statusChanging ? 'Procesando...' : 'Confirmar robo'}
                  </Button>
                </div>
              )}

              {/* Incident comment - flex-grow to fill remaining space */}
              {bicycle.status !== 'vendida' && (
                <div className="flex-1 flex flex-col">
                  <Label className="text-xs text-slate-500 mb-1">Comentario de incidencia</Label>
                  <Textarea 
                    placeholder="Escribe una incidencia o nota de estado..."
                    value={statusComment}
                    onChange={(e) => setStatusComment(e.target.value)}
                    rows={3}
                    className="resize-none text-sm flex-1 min-h-[80px]"
                    data-testid="status-comment-input"
                  />
                </div>
              )}
            </div>
            
            {/* RIGHT COLUMN: General comment */}
            <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg flex flex-col h-full">
              <h4 className="text-sm font-bold text-slate-700 mb-3 uppercase tracking-wide flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-blue-100">
                  <MessageSquare size={16} className="text-blue-600" />
                </div>
                Comentario General
              </h4>
              
              {/* Show existing comment if present */}
              {bicycle.general_comment && (
                <div className="mb-3 p-3 bg-white border border-slate-200 rounded-lg">
                  <p className="text-sm text-slate-700 whitespace-pre-wrap">{bicycle.general_comment}</p>
                </div>
              )}
              
              {/* Comment input - flex-grow to match left column height */}
              <div className="flex-1 flex flex-col">
                <Textarea
                  value={generalComment}
                  onChange={(e) => setGeneralComment(e.target.value)}
                  placeholder="Escribe un comentario general para esta bicicleta..."
                  rows={4}
                  className="resize-none text-sm flex-1 min-h-[120px]"
                  data-testid="general-comment-input"
                />
              </div>
              
              {/* Action buttons */}
              <div className="flex gap-2 justify-end mt-3">
                {bicycle.general_comment && (
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={handleDeleteComment}
                    disabled={savingComment}
                    className="text-red-600 border-red-300 hover:bg-red-50"
                    data-testid="delete-comment-btn"
                  >
                    <Trash2 size={14} className="mr-1" />
                    Borrar
                  </Button>
                )}
                <Button
                  size="sm"
                  onClick={handleSaveComment}
                  disabled={savingComment || !generalComment.trim()}
                  className="bg-blue-600 hover:bg-blue-700"
                  data-testid="save-comment-btn"
                >
                  {savingComment ? (
                    <RefreshCw size={14} className="animate-spin mr-1" />
                  ) : (
                    <Save size={14} className="mr-1" />
                  )}
                  Guardar
                </Button>
              </div>
            </div>
            
          </div>
        </CardContent>
      </Card>

      {/* Info cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Card className="border-slate-200">
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center">
                <Calendar size={18} className="text-slate-600" />
              </div>
              <div>
                <p className="text-xs text-slate-500 uppercase font-semibold">Fecha Alta</p>
                <p className="font-medium text-slate-900">{formatDate(bicycle.created_at)}</p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="border-slate-200">
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                <Wrench size={18} className="text-blue-600" />
              </div>
              <div>
                <p className="text-xs text-slate-500 uppercase font-semibold">Revisiones</p>
                <p className="font-medium text-slate-900">{bicycle.revision_count}</p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="border-slate-200">
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
                <Euro size={18} className="text-orange-600" />
              </div>
              <div>
                <p className="text-xs text-slate-500 uppercase font-semibold">Coste Mantenimiento</p>
                <p className="font-medium text-slate-900">{formatCurrency(bicycle.total_maintenance_cost)}</p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="border-slate-200">
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className="flex-1">
                <p className="text-xs text-slate-500 uppercase font-semibold mb-1">Estado</p>
                {getStatusBadge(bicycle.status)}
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Second-hand Sale Price - Formula-based with manual override */}
      {bicycle.status !== 'vendida' && (
        <Card className="border-slate-200 bg-gradient-to-r from-green-50 to-emerald-50" data-testid="second-hand-price-card">
          <CardContent className="p-6">
            <div className="flex flex-col gap-5">
              {/* Header row with price display */}
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                <div className="flex items-center gap-6">
                  <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center">
                    <Tag size={28} className="text-green-600" />
                  </div>
                  <div>
                    <p className="text-sm text-green-700 font-semibold uppercase tracking-wide flex items-center gap-2">
                      Precio Venta 2ª Mano
                      {secondhandPriceData?.price_type === 'manual' && (
                        <Badge className="bg-amber-100 text-amber-700 border-amber-300 text-xs">
                          <Edit size={10} className="mr-1" /> Manual
                        </Badge>
                      )}
                      {secondhandPriceData?.price_type === 'formula' && (
                        <Badge className="bg-blue-100 text-blue-700 border-blue-300 text-xs">
                          <Calculator size={10} className="mr-1" /> {secondhandPriceData.formula_name}
                        </Badge>
                      )}
                    </p>
                    {loadingPrice ? (
                      <div className="flex items-center gap-2 mt-1">
                        <div className="spinner w-5 h-5" />
                        <span className="text-sm text-slate-500">Calculando...</span>
                      </div>
                    ) : secondhandPriceData ? (
                      <div className="flex items-baseline gap-4">
                        <div>
                          <p className="text-3xl font-bold text-green-800 font-['Barlow_Condensed']" data-testid="second-hand-price-net">
                            {formatCurrency(secondhandPriceData.net_price)}
                          </p>
                          <p className="text-xs text-green-600">Neto</p>
                        </div>
                        <div className="border-l border-green-300 pl-4">
                          <p className="text-3xl font-bold text-green-800 font-['Barlow_Condensed']" data-testid="second-hand-price-iva">
                            {formatCurrency(secondhandPriceData.iva_price)}
                          </p>
                          <p className="text-xs text-green-600">Con IVA (21%)</p>
                        </div>
                      </div>
                    ) : (
                      <p className="text-sm text-slate-400 mt-1">Sin precio de compra configurado</p>
                    )}
                  </div>
                </div>

                {/* Info chips */}
                {secondhandPriceData && (
                  <div className="flex flex-col sm:flex-row gap-3 text-sm">
                    {bicycle.purchase_price > 0 && (
                      <div className="bg-white/60 rounded-lg px-4 py-2">
                        <p className="text-slate-500">Precio Compra</p>
                        <p className="font-semibold text-slate-800">{formatCurrency(bicycle.purchase_price)}</p>
                      </div>
                    )}
                    {secondhandPriceData.months_old !== undefined && secondhandPriceData.months_old !== null && (
                      <div className="bg-white/60 rounded-lg px-4 py-2">
                        <p className="text-slate-500">Antigüedad</p>
                        <p className="font-semibold text-slate-800">{secondhandPriceData.months_old} {secondhandPriceData.months_old === 1 ? 'mes' : 'meses'}</p>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Formula selector and manual price - Admin only */}
              {isAdmin && (
                <div className="border-t border-green-200 pt-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Formula selector */}
                    <div className="space-y-2">
                      <Label className="text-sm text-green-800 font-medium flex items-center gap-1">
                        <Calculator size={14} /> Fórmula de Precio
                      </Label>
                      <Select
                        value={bicycle.secondhand_formula_id || 'default'}
                        onValueChange={(v) => handleApplyFormula(v === 'default' ? '' : v)}
                        disabled={savingFormula}
                      >
                        <SelectTrigger className="bg-white" data-testid="formula-select">
                          <SelectValue placeholder="Seleccionar fórmula..." />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="default">Por defecto (70% precio compra)</SelectItem>
                          {priceFormulas.map(f => (
                            <SelectItem key={f.id} value={f.id}>
                              {f.name} {f.formula_type === 'percentage' ? `(${f.percentage}%)` : f.formula_type === 'fixed' ? `(Fijo)` : ''}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                      {priceFormulas.length === 0 && (
                        <p className="text-xs text-slate-400">No hay fórmulas configuradas. Crea una desde 2ª Mano.</p>
                      )}
                    </div>

                    {/* Manual price override */}
                    <div className="space-y-2">
                      <Label className="text-sm text-green-800 font-medium flex items-center gap-1">
                        <DollarSign size={14} /> Precio Manual (override)
                      </Label>
                      <div className="flex gap-2">
                        <Input
                          type="number"
                          min="0"
                          step="0.01"
                          placeholder="Ej: 500.00"
                          value={manualPriceInput}
                          onChange={(e) => setManualPriceInput(e.target.value)}
                          className="bg-white flex-1"
                          data-testid="manual-price-input"
                        />
                        <Button
                          size="sm"
                          onClick={handleSetManualPrice}
                          disabled={savingFormula || !manualPriceInput}
                          className="bg-green-600 hover:bg-green-700"
                          data-testid="apply-manual-price-btn"
                        >
                          <Save size={14} className="mr-1" /> Aplicar
                        </Button>
                        {secondhandPriceData?.price_type === 'manual' && (
                          <Button
                            size="sm"
                            variant="outline"
                            onClick={handleClearManualPrice}
                            disabled={savingFormula}
                            className="text-red-600 hover:bg-red-50"
                            data-testid="clear-manual-price-btn"
                          >
                            <X size={14} />
                          </Button>
                        )}
                      </div>
                      <p className="text-xs text-slate-400">
                        {secondhandPriceData?.price_type === 'manual' 
                          ? 'El precio manual sobrescribe el cálculo automático.' 
                          : 'Introduce un precio para sobrescribir el cálculo automático.'}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Additional info section - Admin sees all, Mechanic sees frame_number, model_year, warranty */}
      {(isAdmin && (bicycle.photo_url || bicycle.frame_number || bicycle.invoice_number || bicycle.delivery_note_number || bicycle.purchase_price || bicycle.sold_price)) ||
       (!isAdmin && (bicycle.frame_number || bicycle.model_year || bicycle.warranty_active !== undefined)) ? (
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Bike Photo - Admin only */}
        {isAdmin && bicycle.photo_url && !imageError && getImageUrl(bicycle.photo_url) && (
        <Card className="border-slate-200">
          <CardHeader className="pb-2">
            <CardTitle className="text-lg font-['Barlow_Condensed'] flex items-center gap-2">
              <Image size={18} /> Foto
            </CardTitle>
          </CardHeader>
          <CardContent>
            <img 
              src={getImageUrl(bicycle.photo_url)} 
              alt={`Bicicleta ${bicycle.number || 'sin número'}`} 
              className="w-full h-64 object-contain rounded-lg bg-slate-50"
              onError={(e) => {
                e.target.onerror = null;
                setImageError(true);
              }}
            />
          </CardContent>
        </Card>
        )}
        
        {/* Additional Details - Different fields for Admin vs Mechanic */}
        <Card className="border-slate-200">
          <CardHeader className="pb-2">
            <CardTitle className="text-lg font-['Barlow_Condensed'] flex items-center gap-2">
              <FileText size={18} /> Información Adicional
              {!isAdmin && <Badge variant="outline" className="ml-2 text-xs">Solo lectura</Badge>}
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            {/* Frame number - visible to both */}
            {bicycle.frame_number && (
            <div className="flex items-center gap-2 text-sm">
              <Hash size={14} className="text-slate-400" />
              <span className="text-slate-500">Nº Bastidor:</span>
              <span className="font-medium">{bicycle.frame_number}</span>
            </div>
            )}
            {/* Invoice - Admin only */}
            {isAdmin && bicycle.invoice_number && (
            <div className="flex items-center gap-2 text-sm">
              <FileText size={14} className="text-slate-400" />
              <span className="text-slate-500">Nº Factura:</span>
              <span className="font-medium">{bicycle.invoice_number}</span>
            </div>
            )}
            {/* Delivery note - Admin only */}
            {isAdmin && bicycle.delivery_note_number && (
            <div className="flex items-center gap-2 text-sm" data-testid="bike-delivery-note">
              <FileText size={14} className="text-slate-400" />
              <span className="text-slate-500">Nº Albarán:</span>
              <span className="font-medium">{bicycle.delivery_note_number}</span>
            </div>
            )}
            {/* Purchase documents - Admin only */}
            <PurchaseDocs bicycle={bicycle} isAdmin={isAdmin} onUpdated={fetchBicycle} />
            {/* Purchase date - Admin only */}
            {isAdmin && bicycle.purchase_date && (
            <div className="flex items-center gap-2 text-sm">
              <Calendar size={14} className="text-slate-400" />
              <span className="text-slate-500">Fecha Compra:</span>
              <span className="font-medium">{formatDate(bicycle.purchase_date)}</span>
            </div>
            )}
            {/* Model year - visible to both */}
            {bicycle.model_year && (
            <div className="flex items-center gap-2 text-sm">
              <Calendar size={14} className="text-blue-400" />
              <span className="text-slate-500">Año del Modelo:</span>
              <span className="font-medium text-blue-600">{bicycle.model_year}</span>
            </div>
            )}
            {/* Purchase price - Admin only */}
            {isAdmin && bicycle.purchase_price !== null && (
            <div className="flex items-center gap-2 text-sm">
              <Euro size={14} className="text-slate-400" />
              <span className="text-slate-500">Precio Compra:</span>
              <span className="font-medium">{formatCurrency(bicycle.purchase_price)}</span>
            </div>
            )}
            {/* Warranty - visible to both */}
            <div className="flex items-center gap-2 text-sm">
              <Shield size={14} className={bicycle.warranty_active ? "text-green-500" : "text-slate-400"} />
              <span className="text-slate-500">Garantía:</span>
              <Badge variant="outline" className={bicycle.warranty_active ? "bg-green-50 text-green-700" : "bg-slate-50"}>
                {bicycle.warranty_active ? 'Activa' : 'No activa'}
              </Badge>
            </div>
          </CardContent>
        </Card>
      </div>
      ) : null}

      {/* Sale info - if sold */}
      {isAdmin && bicycle.status !== 'vendida' && <ShopPublish bicycle={bicycle} />}

      {bicycle.status === 'vendida' && isAdmin && (
      <Card className="border-green-200 bg-green-50">
        <CardHeader className="pb-2 flex flex-row items-center justify-between">
          <CardTitle className="text-lg font-['Barlow_Condensed'] flex items-center gap-2 text-green-800">
            <ShoppingCart size={18} /> Información de Venta
          </CardTitle>
          <Button
            variant="outline"
            size="sm"
            onClick={openEditSaleDialog}
            className="gap-2 bg-white hover:bg-green-100 border-green-300"
            data-testid="edit-sale-data-btn"
          >
            <Edit size={14} />
            Editar Venta
          </Button>
        </CardHeader>
        <CardContent className="space-y-4">
          {/* Main sale info */}
          <div className="grid grid-cols-2 md:grid-cols-6 gap-4">
            <div>
              <p className="text-xs text-green-600 uppercase font-semibold">Fecha Venta</p>
              <p className="font-medium text-green-900">{formatDate(bicycle.sold_date)}</p>
            </div>
            <div>
              <p className="text-xs text-green-600 uppercase font-semibold">Vendido a</p>
              <p className="font-medium text-green-900">{bicycle.sold_to || <span className="text-green-400 italic">Sin especificar</span>}</p>
            </div>
            <div>
              <p className="text-xs text-green-600 uppercase font-semibold">Precio Venta</p>
              <p className="font-medium text-green-900">{formatCurrency(bicycle.sold_price)}</p>
              {bicycle.payment_status === 'pendiente' && (
                <Link to="/sold-pending" className="inline-block mt-1" data-testid="pending-collection-badge">
                  <Badge className="bg-orange-100 text-orange-700 border-orange-300 text-[10px]">
                    Pendiente de cobro: {formatCurrency(bicycle.amount_pending)}
                  </Badge>
                </Link>
              )}
            </div>
            <div>
              <p className="text-xs text-green-600 uppercase font-semibold">Ingresos Alquiler</p>
              <p className="font-medium text-green-900">{formatCurrency(bicycle.rental_income || 0)}</p>
            </div>
            <div>
              <p className="text-xs text-green-600 uppercase font-semibold">Total Invertido</p>
              <p className="font-medium text-green-900">
                {formatCurrency((bicycle.purchase_price || 0) + (bicycle.total_maintenance_cost || 0))}
              </p>
            </div>
            <div>
              <p className="text-xs text-green-600 uppercase font-semibold">Beneficio</p>
              <p className={`font-bold text-lg ${bicycle.profit >= 0 ? 'text-green-700' : 'text-red-600'}`}>
                {formatCurrency(bicycle.profit)}
              </p>
            </div>
          </div>
          
          {/* Sale invoice section */}
          <div className="pt-4 border-t border-green-200">
            <div className="flex items-center justify-between mb-3">
              <h4 className="text-sm font-semibold text-green-700 uppercase flex items-center gap-2">
                <FileText size={16} /> Factura de Venta
              </h4>
            </div>
            
            {bicycle.sale_invoice_url ? (
              <div className="flex items-center gap-4 bg-white rounded-lg p-3 border border-green-200">
                {bicycle.sale_invoice_url.endsWith('.pdf') ? (
                  <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <FileText size={24} className="text-red-600" />
                  </div>
                ) : (
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0 overflow-hidden">
                    <img 
                      src={`${BACKEND_URL}${bicycle.sale_invoice_url}`}
                      alt="Factura de venta"
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.parentElement.innerHTML = '<div class="w-12 h-12 flex items-center justify-center"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-green-600"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg></div>';
                      }}
                    />
                  </div>
                )}
                <div className="flex-1">
                  <p className="text-sm font-medium text-slate-800">
                    {bicycle.sale_invoice_url.endsWith('.pdf') ? 'Documento PDF' : 'Imagen'}
                  </p>
                  <p className="text-xs text-slate-500">
                    {bicycle.sale_invoice_url.split('/').pop()}
                  </p>
                </div>
                <div className="flex gap-2">
                  <a 
                    href={`${BACKEND_URL}${bicycle.sale_invoice_url}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 px-3 py-1.5 text-xs bg-green-600 text-white rounded-lg hover:bg-green-700"
                  >
                    <FileText size={14} />
                    Ver / Descargar
                  </a>
                  <label className="cursor-pointer">
                    <input
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
                      onChange={handleInvoiceUpload}
                      className="hidden"
                      disabled={uploadingInvoice}
                    />
                    <span className="inline-flex items-center gap-1 px-3 py-1.5 text-xs bg-white border border-green-300 text-green-700 rounded-lg hover:bg-green-50 cursor-pointer">
                      {uploadingInvoice ? (
                        <>
                          <RefreshCw size={14} className="animate-spin" />
                          Subiendo...
                        </>
                      ) : (
                        <>
                          <Upload size={14} />
                          Cambiar
                        </>
                      )}
                    </span>
                  </label>
                </div>
              </div>
            ) : (
              <div className="bg-white rounded-lg p-4 border border-dashed border-green-300 text-center">
                <FileText size={32} className="mx-auto text-green-300 mb-2" />
                <p className="text-sm text-green-600 mb-3">No hay factura adjunta</p>
                <label className="cursor-pointer">
                  <input
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
                    onChange={handleInvoiceUpload}
                    className="hidden"
                    disabled={uploadingInvoice}
                    data-testid="sale-invoice-upload"
                  />
                  <span className="inline-flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 cursor-pointer">
                    {uploadingInvoice ? (
                      <>
                        <RefreshCw size={16} className="animate-spin" />
                        Subiendo...
                      </>
                    ) : (
                      <>
                        <Upload size={16} />
                        Subir Factura (PDF o imagen)
                      </>
                    )}
                  </span>
                </label>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
      )}

      {/* Edit Sale Data Dialog */}
      <Dialog open={isEditSaleDialogOpen} onOpenChange={setIsEditSaleDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="text-xl font-['Barlow_Condensed'] flex items-center gap-2">
              <Edit size={20} /> Editar Datos de Venta
            </DialogTitle>
          </DialogHeader>
          <form onSubmit={handleUpdateSaleData} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="edit_sold_to">Vendido a</Label>
              <Input
                id="edit_sold_to"
                type="text"
                placeholder="Nombre del comprador"
                value={editSaleData.sold_to}
                onChange={(e) => setEditSaleData({...editSaleData, sold_to: e.target.value})}
                data-testid="edit-sold-to-input"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="edit_sold_price">Precio de Venta (€)</Label>
              <Input
                id="edit_sold_price"
                type="number"
                step="0.01"
                min="0"
                placeholder="Ej: 1500.00"
                value={editSaleData.sold_price}
                onChange={(e) => setEditSaleData({...editSaleData, sold_price: e.target.value})}
                required
                data-testid="edit-sold-price-input"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="edit_rental_income">Ingresos por Alquiler (€)</Label>
              <Input
                id="edit_rental_income"
                type="number"
                step="0.01"
                min="0"
                placeholder="Ej: 200.00"
                value={editSaleData.rental_income}
                onChange={(e) => setEditSaleData({...editSaleData, rental_income: e.target.value})}
                data-testid="edit-rental-income-input"
              />
            </div>
            <div className="p-3 bg-slate-100 rounded-lg">
              <div className="flex justify-between items-center text-sm">
                <span className="text-slate-600">Nuevo Beneficio Calculado:</span>
                <span className={`font-bold ${
                  ((parseFloat(editSaleData.sold_price) || 0) + 
                   (parseFloat(editSaleData.rental_income) || 0) - 
                   (bicycle?.purchase_price || 0) - 
                   (bicycle?.total_maintenance_cost || 0)) >= 0 
                    ? 'text-green-600' : 'text-red-600'
                }`}>
                  {formatCurrency(
                    (parseFloat(editSaleData.sold_price) || 0) + 
                    (parseFloat(editSaleData.rental_income) || 0) - 
                    (bicycle?.purchase_price || 0) - 
                    (bicycle?.total_maintenance_cost || 0)
                  )}
                </span>
              </div>
            </div>
            <DialogFooter className="gap-2">
              <Button type="button" variant="outline" onClick={() => setIsEditSaleDialogOpen(false)}>
                Cancelar
              </Button>
              <Button type="submit" className="bg-green-600 hover:bg-green-700" data-testid="save-sale-data-btn">
                Guardar Cambios
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>

      {/* Material Statistics Block */}
      {bicycle.revisions?.length > 0 && (
        <Card className="border-slate-200 bg-gradient-to-r from-orange-50 to-amber-50" data-testid="material-stats">
          <CardHeader className="pb-2">
            <CardTitle className="text-xl font-['Barlow_Condensed'] flex items-center gap-2 text-orange-800">
              <Package size={20} /> Resumen de Materiales Utilizados
            </CardTitle>
          </CardHeader>
          <CardContent>
            {(() => {
              // Calculate material totals from all revisions
              const materialTotals = {};
              let totalCost = 0;
              let totalItems = 0;
              
              bicycle.revisions.forEach(revision => {
                revision.materials?.forEach(mat => {
                  const key = mat.material_name;
                  if (!materialTotals[key]) {
                    materialTotals[key] = { quantity: 0, cost: 0 };
                  }
                  materialTotals[key].quantity += mat.quantity;
                  materialTotals[key].cost += mat.total_price;
                  totalCost += mat.total_price;
                  totalItems += mat.quantity;
                });
              });
              
              const sortedMaterials = Object.entries(materialTotals)
                .sort((a, b) => b[1].cost - a[1].cost);
              
              return (
                <div className="space-y-4">
                  {/* Summary cards */}
                  <div className="grid grid-cols-3 gap-4">
                    <div className="bg-white rounded-lg p-3 border border-orange-200 text-center">
                      <p className="text-2xl font-bold text-orange-600 font-['Barlow_Condensed']">
                        {bicycle.revision_count || bicycle.revisions.length}
                      </p>
                      <p className="text-xs text-orange-500 uppercase font-semibold">Revisiones</p>
                    </div>
                    <div className="bg-white rounded-lg p-3 border border-orange-200 text-center">
                      <p className="text-2xl font-bold text-orange-600 font-['Barlow_Condensed']">
                        {sortedMaterials.length}
                      </p>
                      <p className="text-xs text-orange-500 uppercase font-semibold">Materiales Diferentes</p>
                    </div>
                    <div className="bg-white rounded-lg p-3 border border-orange-200 text-center">
                      <p className="text-2xl font-bold text-orange-600 font-['Barlow_Condensed']">
                        {formatCurrency(totalCost)}
                      </p>
                      <p className="text-xs text-orange-500 uppercase font-semibold">Coste Total</p>
                    </div>
                  </div>
                  
                  {/* Top materials list */}
                  {sortedMaterials.length > 0 && (
                    <div className="space-y-2">
                      <p className="text-sm font-semibold text-orange-700">Materiales más utilizados:</p>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                        {sortedMaterials.slice(0, 6).map(([name, data], index) => (
                          <div key={name} className="flex items-center justify-between bg-white rounded-lg px-3 py-2 border border-orange-100">
                            <div className="flex items-center gap-2">
                              <span className="w-5 h-5 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center text-xs font-semibold">
                                {index + 1}
                              </span>
                              <span className="text-sm text-slate-700 truncate max-w-[150px]">{name}</span>
                            </div>
                            <div className="text-right">
                              <span className="text-sm font-semibold text-orange-600">{formatCurrency(data.cost)}</span>
                              <span className="text-xs text-slate-400 ml-1">({data.quantity} uds)</span>
                            </div>
                          </div>
                        ))}
                      </div>
                      {sortedMaterials.length > 6 && (
                        <p className="text-xs text-slate-400 text-center">
                          + {sortedMaterials.length - 6} materiales más
                        </p>
                      )}
                    </div>
                  )}
                </div>
              );
            })()}
          </CardContent>
        </Card>
      )}

      {/* Stolen Info & Attachments */}
      {bicycle.status === 'robada' && (
        <Card className="border-red-200 bg-red-50/30" data-testid="stolen-section">
          <CardHeader>
            <CardTitle className="text-xl font-['Barlow_Condensed'] text-red-800 flex items-center gap-2">
              <AlertTriangle size={20} />
              Información de Robo
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {bicycle.stolen_date && (
                <div>
                  <p className="text-xs text-red-600 font-medium uppercase">Fecha del robo</p>
                  <p className="text-sm font-semibold text-slate-800">{formatDate(bicycle.stolen_date)}</p>
                </div>
              )}
              {bicycle.stolen_notes && (
                <div>
                  <p className="text-xs text-red-600 font-medium uppercase">Notas</p>
                  <p className="text-sm text-slate-700">{bicycle.stolen_notes}</p>
                </div>
              )}
            </div>

            {/* Attachments */}
            <div className="border-t border-red-200 pt-3">
              <div className="flex items-center justify-between mb-2">
                <p className="text-xs text-red-600 font-medium uppercase">
                  Archivos adjuntos ({(bicycle.stolen_attachments || []).length})
                </p>
                {isAdmin && (
                  <label className="cursor-pointer">
                    <input type="file" className="hidden" accept="image/*,.pdf"
                      onChange={handleStolenFileUpload} disabled={uploadingStolenFile}
                      data-testid="stolen-file-input" />
                    <span className="inline-flex items-center gap-1 text-xs font-medium text-red-700 hover:text-red-900 border border-red-300 rounded-md px-2 py-1 hover:bg-red-100 transition-colors">
                      <Upload size={12} />
                      {uploadingStolenFile ? 'Subiendo...' : 'Adjuntar archivo'}
                    </span>
                  </label>
                )}
              </div>

              {(bicycle.stolen_attachments || []).length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                  {bicycle.stolen_attachments.map((att) => (
                    <div key={att.id} className="flex items-center gap-2 p-2 bg-white rounded-lg border border-red-100 group"
                      data-testid={`stolen-attachment-${att.id}`}>
                      {att.file_type === 'image' ? (
                        <a href={att.file_url} target="_blank" rel="noopener noreferrer"
                          className="w-12 h-12 rounded overflow-hidden flex-shrink-0 border">
                          <img src={att.file_url} alt={att.file_name} className="w-full h-full object-cover" />
                        </a>
                      ) : (
                        <a href={att.file_url} target="_blank" rel="noopener noreferrer"
                          className="w-12 h-12 rounded bg-red-100 flex items-center justify-center flex-shrink-0 border">
                          <FileText size={20} className="text-red-600" />
                        </a>
                      )}
                      <div className="flex-1 min-w-0">
                        <a href={att.file_url} target="_blank" rel="noopener noreferrer"
                          className="text-xs font-medium text-slate-700 hover:text-red-700 truncate block">
                          {att.file_name}
                        </a>
                        <p className="text-[10px] text-slate-400">
                          {att.uploaded_by} · {new Date(att.upload_date).toLocaleDateString('es-ES')}
                        </p>
                      </div>
                      {isAdmin && (
                        <button onClick={() => handleDeleteStolenAttachment(att.id)}
                          className="opacity-0 group-hover:opacity-100 text-slate-400 hover:text-red-600 transition-opacity p-1"
                          data-testid={`delete-attachment-${att.id}`}>
                          <Trash2 size={14} />
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-xs text-slate-400 italic">No hay archivos adjuntos</p>
              )}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Lifecycle History */}
      {lifecycles && lifecycles.lifecycles?.length > 0 && (
        <Card className="border-slate-200" data-testid="lifecycle-history">
          <CardHeader>
            <div className="flex items-center justify-between">
              <CardTitle className="text-xl font-['Barlow_Condensed']">
                Ciclos de Vida
              </CardTitle>
              <div className="flex items-center gap-3">
                <Badge variant="outline" className="text-sm">
                  Ciclo actual: #{lifecycles.current_lifecycle_id}
                </Badge>
                {lifecycles.total_profit !== 0 && (
                  <Badge variant="outline" className={`text-sm ${lifecycles.total_profit >= 0 ? 'bg-green-50 text-green-700 border-green-200' : 'bg-red-50 text-red-700 border-red-200'}`}>
                    Beneficio total: {formatCurrency(lifecycles.total_profit)}
                  </Badge>
                )}
              </div>
            </div>
          </CardHeader>
          <CardContent className="space-y-3">
            {lifecycles.lifecycles.map((lc) => (
              <div key={lc.id} className={`p-4 rounded-lg border ${lc.status === 'active' ? 'border-blue-200 bg-blue-50/50' : 'border-slate-200 bg-slate-50'}`}
                data-testid={`lifecycle-${lc.lifecycle_id}`}>
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <span className="font-semibold text-sm">Ciclo #{lc.lifecycle_id}</span>
                    <Badge variant="outline" className={`text-xs ${lc.status === 'active' ? 'bg-blue-100 text-blue-700' : 'bg-slate-100 text-slate-600'}`}>
                      {lc.status === 'active' ? 'Activo' : 'Cerrado'}
                    </Badge>
                  </div>
                  {lc.profit != null && (
                    <span className={`text-sm font-semibold ${lc.profit >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                      {lc.profit >= 0 ? '+' : ''}{formatCurrency(lc.profit)}
                    </span>
                  )}
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 text-xs text-slate-600">
                  <div><span className="font-medium">Compra:</span> {formatCurrency(lc.purchase_price || 0)}</div>
                  {lc.sale_price != null && <div><span className="font-medium">Venta:</span> {formatCurrency(lc.sale_price)}</div>}
                  <div><span className="font-medium">Inicio:</span> {lc.start_date ? new Date(lc.start_date).toLocaleDateString('es-ES') : '-'}</div>
                  {lc.end_date && <div><span className="font-medium">Fin:</span> {new Date(lc.end_date).toLocaleDateString('es-ES')}</div>}
                </div>
                {lc.movements?.length > 0 && (
                  <div className="mt-2 border-t pt-2 space-y-1">
                    {lc.movements.map((mv, i) => (
                      <div key={i} className="flex items-center gap-2 text-xs text-slate-500">
                        <span className={`inline-block w-2 h-2 rounded-full flex-shrink-0 ${
                          mv.action === 'purchase' ? 'bg-blue-400' :
                          mv.action === 'repurchase' ? 'bg-purple-400' :
                          mv.action === 'sale' ? 'bg-green-400' : 'bg-slate-400'
                        }`} />
                        <span className="font-medium">{mv.action === 'purchase' ? 'Alta' : mv.action === 'repurchase' ? 'Recompra' : mv.action === 'sale' ? 'Venta' : mv.action}</span>
                        <span>— {mv.user}</span>
                        <span className="ml-auto">{new Date(mv.date).toLocaleDateString('es-ES')}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </CardContent>
        </Card>
      )}

      {/* Revisions list */}
      <Card className="border-slate-200" data-testid="revisions-list">
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle className="text-xl font-['Barlow_Condensed']">Historial de Revisiones</CardTitle>
          {bicycle.revisions?.length > 0 && (
            <Button
              variant="outline"
              size="sm"
              onClick={() => setIsHistoryDialogOpen(true)}
              className="gap-2"
              data-testid="detailed-history-btn"
            >
              <List size={16} />
              Ver Detalle
            </Button>
          )}
        </CardHeader>
        <CardContent>
          {bicycle.revisions?.length === 0 ? (
            <div className="text-center py-12 text-slate-400">
              <Wrench size={48} className="mx-auto mb-4 opacity-50" />
              <p>No hay revisiones registradas</p>
              <p className="text-sm">Añade la primera revisión para esta bicicleta</p>
            </div>
          ) : (
            <div className="space-y-4">
              {bicycle.revisions?.map((revision, index) => (
                <div 
                  key={revision.id} 
                  className="border border-slate-200 rounded-lg p-4 hover:bg-slate-50 transition-colors"
                  data-testid={`revision-${revision.id}`}
                  style={{ animationDelay: `${index * 50}ms` }}
                >
                  <div className="flex items-start justify-between gap-4">
                    <div className="flex-1">
                      <p className="font-medium text-slate-900 mb-2">{revision.description}</p>
                      <div className="flex flex-wrap gap-4 text-sm text-slate-500">
                        <span className="flex items-center gap-1">
                          <Calendar size={14} />
                          {formatDate(revision.date)}
                        </span>
                        <span className="flex items-center gap-1">
                          <User size={14} />
                          {revision.mechanic_name}
                        </span>
                        {/* Show km for electric bikes */}
                        {bicycle.is_electric && revision.current_km !== null && revision.current_km !== undefined && (
                          <span className="flex items-center gap-1 text-yellow-600 font-medium">
                            <Gauge size={14} />
                            {revision.current_km.toLocaleString()} km
                          </span>
                        )}
                      </div>
                      
                      {revision.materials?.length > 0 && (
                        <div className="mt-3 pt-3 border-t border-slate-100">
                          <p className="text-xs font-semibold text-slate-500 uppercase mb-2 flex items-center gap-1">
                            <Package size={12} />
                            Materiales
                          </p>
                          <div className="flex flex-wrap gap-2">
                            {revision.materials.map((mat, idx) => (
                              <Badge key={idx} variant="outline" className="bg-slate-50">
                                {mat.material_name} x{mat.quantity} - {formatCurrency(mat.total_price)}
                              </Badge>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                    
                    <div className="flex flex-col items-end gap-2">
                      <Badge className="bg-orange-100 text-orange-700 border-orange-200">
                        {formatCurrency(revision.total_cost)}
                      </Badge>
                      {isAdmin && (
                        <div className="flex gap-1">
                          <Button
                            variant="ghost"
                            size="sm"
                            onClick={() => handleOpenEditRevision(revision)}
                            className="text-blue-500 hover:text-blue-600 hover:bg-blue-50"
                            data-testid={`edit-revision-${revision.id}`}
                          >
                            <Edit size={14} />
                          </Button>
                          <Button
                            variant="ghost"
                            size="sm"
                            onClick={() => setDeleteRevisionId(revision.id)}
                            className="text-red-500 hover:text-red-600 hover:bg-red-50"
                            data-testid={`delete-revision-${revision.id}`}
                          >
                            <Trash2 size={14} />
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>

      {/* Delete revision dialog */}
      <Dialog open={!!deleteRevisionId} onOpenChange={() => setDeleteRevisionId(null)}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="text-xl font-['Barlow_Condensed']">Eliminar Revisión</DialogTitle>
          </DialogHeader>
          <p className="text-slate-600">
            ¿Estás seguro de que quieres eliminar esta revisión? Esta acción no se puede deshacer.
          </p>
          <DialogFooter className="gap-2">
            <Button variant="outline" onClick={() => setDeleteRevisionId(null)}>
              Cancelar
            </Button>
            <Button 
              variant="destructive" 
              onClick={handleDeleteRevision}
              data-testid="confirm-delete-revision-btn"
            >
              Eliminar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Edit Revision Dialog */}
      <Dialog open={isEditRevisionDialogOpen} onOpenChange={setIsEditRevisionDialogOpen}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-xl font-['Barlow_Condensed'] flex items-center gap-2">
              <Edit size={20} /> Editar Revisión
            </DialogTitle>
          </DialogHeader>
          <form onSubmit={handleSaveEditRevision} className="space-y-4">
            {/* Description */}
            <div className="space-y-2">
              <Label htmlFor="edit-revision-description">Descripción</Label>
              <Textarea
                id="edit-revision-description"
                value={editRevisionData.description}
                onChange={(e) => setEditRevisionData({ ...editRevisionData, description: e.target.value })}
                placeholder="Descripción de la revisión..."
                rows={2}
                required
                data-testid="edit-revision-description-input"
              />
            </div>
            
            {/* Km for electric bikes */}
            {bicycle?.is_electric && (
              <div className="space-y-2">
                <Label htmlFor="edit-revision-km">Kilometraje actual</Label>
                <Input
                  id="edit-revision-km"
                  type="number"
                  min="0"
                  value={editRevisionData.current_km}
                  onChange={(e) => setEditRevisionData({ ...editRevisionData, current_km: e.target.value })}
                  placeholder="Ej: 1500"
                  data-testid="edit-revision-km-input"
                />
              </div>
            )}
            
            {/* Materials section */}
            <div className="space-y-3">
              <Label className="flex items-center gap-2">
                <Package size={16} />
                Materiales
              </Label>
              
              {/* Material search */}
              <div className="p-3 bg-slate-50 rounded-lg border">
                <p className="text-xs text-slate-500 mb-2">Buscar y añadir materiales:</p>
                <div className="flex gap-2">
                  <div className="flex-1">
                    <Select
                      value=""
                      onValueChange={(materialId) => {
                        const material = materials.find(m => m.id === materialId);
                        if (material) handleEditAddMaterial(material);
                      }}
                    >
                      <SelectTrigger data-testid="edit-material-select">
                        <SelectValue placeholder="Seleccionar material..." />
                      </SelectTrigger>
                      <SelectContent>
                        <div className="p-2">
                          <Input
                            placeholder="Filtrar materiales..."
                            value={editMaterialFilters.search || ''}
                            onChange={(e) => setEditMaterialFilters({ ...editMaterialFilters, search: e.target.value })}
                            className="mb-2"
                          />
                        </div>
                        {materials
                          .filter(m => !editMaterialFilters.search || 
                            m.name.toLowerCase().includes(editMaterialFilters.search.toLowerCase()) ||
                            m.category?.toLowerCase().includes(editMaterialFilters.search.toLowerCase())
                          )
                          .slice(0, 50)
                          .map(material => (
                            <SelectItem key={material.id} value={material.id}>
                              <span className="flex items-center gap-2">
                                <span>{material.name}</span>
                                <span className="text-slate-400 text-xs">({formatCurrency(material.price)})</span>
                              </span>
                            </SelectItem>
                          ))}
                      </SelectContent>
                    </Select>
                  </div>
                </div>
              </div>
              
              {/* Materials list */}
              {editRevisionData.materials.length > 0 ? (
                <div className="space-y-2">
                  {editRevisionData.materials.map((mat, idx) => (
                    <div key={idx} className="flex items-center gap-2 p-2 bg-slate-50 rounded-lg border">
                      <div className="flex-1">
                        <p className="font-medium text-sm">{mat.material_name}</p>
                        <p className="text-xs text-slate-500">{formatCurrency(mat.unit_price)} / ud</p>
                      </div>
                      <div className="flex items-center gap-2">
                        <Label className="text-xs text-slate-500">Cant:</Label>
                        <Input
                          type="number"
                          min="1"
                          value={mat.quantity}
                          onChange={(e) => handleEditUpdateMaterial(idx, 'quantity', parseInt(e.target.value) || 1)}
                          className="w-16 h-8 text-center"
                          data-testid={`edit-material-qty-${idx}`}
                        />
                      </div>
                      <div className="text-right min-w-[70px]">
                        <p className="font-semibold text-orange-600">{formatCurrency(mat.total_price)}</p>
                      </div>
                      <Button
                        type="button"
                        variant="ghost"
                        size="sm"
                        onClick={() => handleEditRemoveMaterial(idx)}
                        className="text-red-500 hover:text-red-600 hover:bg-red-50 h-8 w-8 p-0"
                        data-testid={`edit-remove-material-${idx}`}
                      >
                        <X size={14} />
                      </Button>
                    </div>
                  ))}
                  
                  {/* Total */}
                  <div className="flex justify-end pt-2 border-t">
                    <div className="bg-orange-100 px-4 py-2 rounded-lg">
                      <span className="text-sm text-orange-700 font-semibold">
                        Total: {formatCurrency(editRevisionData.materials.reduce((sum, m) => sum + m.total_price, 0))}
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-center py-4 text-slate-400 text-sm">
                  No hay materiales añadidos
                </div>
              )}
            </div>
            
            <DialogFooter className="gap-2 pt-4">
              <Button type="button" variant="outline" onClick={() => setIsEditRevisionDialogOpen(false)}>
                Cancelar
              </Button>
              <Button type="submit" className="bg-blue-600 hover:bg-blue-700" data-testid="save-edit-revision-btn">
                Guardar Cambios
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>

      {/* Detailed History Dialog */}
      <Dialog open={isHistoryDialogOpen} onOpenChange={setIsHistoryDialogOpen}>
        <DialogContent className="max-w-4xl max-h-[85vh] overflow-hidden flex flex-col">
          <DialogHeader>
            <DialogTitle className="text-xl font-['Barlow_Condensed'] flex items-center gap-2">
              <List size={20} />
              Historial Detallado de Revisiones
            </DialogTitle>
          </DialogHeader>
          
          <div className="flex-1 overflow-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 sticky top-0">
                <tr>
                  <th 
                    className="text-left p-3 font-semibold text-slate-700 cursor-pointer hover:bg-slate-100 transition-colors"
                    onClick={() => toggleSort('date')}
                  >
                    <div className="flex items-center gap-2">
                      <Calendar size={14} />
                      Fecha
                      <SortIcon field="date" />
                    </div>
                  </th>
                  <th className="text-left p-3 font-semibold text-slate-700">
                    <div className="flex items-center gap-2">
                      <FileText size={14} />
                      Descripción
                    </div>
                  </th>
                  <th 
                    className="text-left p-3 font-semibold text-slate-700 cursor-pointer hover:bg-slate-100 transition-colors"
                    onClick={() => toggleSort('material')}
                  >
                    <div className="flex items-center gap-2">
                      <Package size={14} />
                      Material
                      <SortIcon field="material" />
                    </div>
                  </th>
                  <th className="text-center p-3 font-semibold text-slate-700">Cant.</th>
                  <th className="text-right p-3 font-semibold text-slate-700">Precio Unit.</th>
                  <th className="text-right p-3 font-semibold text-slate-700">Total</th>
                  <th className="text-left p-3 font-semibold text-slate-700">
                    <div className="flex items-center gap-2">
                      <User size={14} />
                      Mecánico
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {getSortedHistory().map((item, index) => (
                  <tr 
                    key={`${item.revisionId}-${index}`}
                    className="hover:bg-slate-50 transition-colors"
                  >
                    <td className="p-3 text-slate-600 whitespace-nowrap">
                      {formatDate(item.date)}
                    </td>
                    <td className="p-3 text-slate-800 max-w-[200px] truncate" title={item.description}>
                      {item.description}
                    </td>
                    <td className="p-3">
                      {item.materialName === '(Sin materiales)' ? (
                        <span className="text-slate-400 italic">{item.materialName}</span>
                      ) : (
                        <Badge variant="outline" className="bg-blue-50 text-blue-700 border-blue-200">
                          {item.materialName}
                        </Badge>
                      )}
                    </td>
                    <td className="p-3 text-center text-slate-600">
                      {item.quantity > 0 ? item.quantity : '-'}
                    </td>
                    <td className="p-3 text-right text-slate-600">
                      {item.unitPrice > 0 ? formatCurrency(item.unitPrice) : '-'}
                    </td>
                    <td className="p-3 text-right font-medium text-slate-800">
                      {item.totalPrice > 0 ? formatCurrency(item.totalPrice) : '-'}
                    </td>
                    <td className="p-3 text-slate-600">
                      {item.mechanicName}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="bg-slate-100 font-semibold">
                <tr>
                  <td colSpan={5} className="p-3 text-right text-slate-700">
                    Total Mantenimiento:
                  </td>
                  <td className="p-3 text-right text-orange-600">
                    {formatCurrency(bicycle?.total_maintenance_cost || 0)}
                  </td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
          
          <div className="pt-4 border-t flex items-center justify-between text-sm text-slate-500">
            <span>
              {getSortedHistory().length} registros · {bicycle?.revisions?.length || 0} revisiones
            </span>
            <Button variant="outline" onClick={() => setIsHistoryDialogOpen(false)}>
              Cerrar
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Unsaved changes warning dialog */}
      <AlertDialog open={!!pendingNavigation} onOpenChange={(open) => !open && cancelNavigation()}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>¿Cambiar de bicicleta?</AlertDialogTitle>
            <AlertDialogDescription>
              Si tienes el formulario de edición abierto, los cambios no guardados se perderán.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={cancelNavigation}>Cancelar</AlertDialogCancel>
            <AlertDialogAction onClick={confirmNavigation}>
              Continuar sin guardar
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Print Label Modal */}
      <PrintLabelModal
        open={isPrintLabelOpen}
        onClose={() => setIsPrintLabelOpen(false)}
        bicycle={bicycle}
      />
    </div>
  );
}

// Inline editor for the PIN of "Cambio electrónico" displayed inside the Componentes list.
// Accessible by all users (uses the dedicated /electronic-shifting endpoint).
function ComponentsPinEditor({ bicycleId, initial, onSaved }) {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(initial || '');
  const [saving, setSaving] = useState(false);

  useEffect(() => { setValue(initial || ''); }, [initial]);

  const cancel = () => { setValue(initial || ''); setEditing(false); };

  const save = async () => {
    const code = (value || '').trim();
    // Empty is allowed (clears the PIN); if non-empty, must be exactly 6 digits.
    if (code && !/^\d{6}$/.test(code)) {
      toast.error('El PIN debe ser 6 dígitos numéricos (o vacío)');
      return;
    }
    setSaving(true);
    try {
      await axios.put(`${API}/bicycles/${bicycleId}/electronic-shifting`, {
        cambio_electronico: true,
        codigo_bloqueo: code || '',
      });
      toast.success(code ? 'PIN actualizado' : 'PIN borrado');
      setEditing(false);
      onSaved && onSaved();
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Error al actualizar el PIN');
    } finally {
      setSaving(false);
    }
  };

  if (!editing) {
    const hasValue = (initial || '').trim().length > 0;
    return (
      <div className="flex items-center gap-2">
        <p
          className={`font-mono text-lg font-bold tracking-[0.3em] ${hasValue ? 'text-blue-800' : 'text-blue-300 italic'}`}
          data-testid="components-pin-value"
        >
          {hasValue ? initial : 'sin definir'}
        </p>
        <Button
          type="button"
          size="sm"
          variant="ghost"
          className="h-7 px-2 text-blue-600 hover:text-blue-800 hover:bg-blue-100"
          onClick={() => setEditing(true)}
          data-testid="components-pin-edit-btn"
        >
          <Pencil size={12} />
        </Button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1.5 mt-0.5">
      <Input
        autoFocus
        value={value}
        onChange={(e) => {
          const v = e.target.value.replace(/\D/g, '').slice(0, 6);
          setValue(v);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') save();
          if (e.key === 'Escape') cancel();
        }}
        maxLength={6}
        placeholder="6 dígitos (opcional)"
        className="h-8 w-36 font-mono tracking-[0.2em] text-base"
        data-testid="components-pin-input"
      />
      <Button
        type="button"
        size="sm"
        className="h-8 bg-blue-600 hover:bg-blue-700 text-white px-2"
        onClick={save}
        disabled={saving || (value.length > 0 && value.length !== 6)}
        data-testid="components-pin-save-btn"
      >
        <Check size={14} />
      </Button>
      <Button
        type="button"
        size="sm"
        variant="ghost"
        className="h-8 px-2"
        onClick={cancel}
        disabled={saving}
        data-testid="components-pin-cancel-btn"
      >
        <X size={14} />
      </Button>
    </div>
  );
}
